<template>

  <div class="row hidden_" id="story">
    
    <div class="overlay">
      <a class="close" v-on:click="hideOverlay"><i class="fas fa-window-close"></i></a>
      <h2>Changing burden overtime around the world (colorectal cancer incidence and mortality) - {{ this.name }} </h2>

      <div id="viz3_1">
        <form name="filter_overlay">
          <select name="country_current" v-model="country_model" placeholder="Choose a country" v-on:change="changeCountry">
            <option v-for="country in list_circles" v-bind:key="country.ISO_3_CODE" :value="country.UN_CODE">{{ country.CNTRY_TERR }}</option>
          </select>
        </form>
      </div>
    </div>

    <!-- Sunburst -->
    <Scrollama
      id="section_1"
      :debug="false"
      :offset="0"
      @step-enter="stepEnter"
    >
      <div class="graphic" slot="graphic">
        <h2 class="story_marker">The story of gastrointestinal cancers</h2>
        <h3 class="graphic_title">Overall burden</h3>
        <p class="desc" data-aos="fade-down">Globally, gastrointestinal cancers (GI) are responsible for 1 in 4 cancer cases and 1 in 3 cancer deaths</p>
        <div id="viz1" class="viz">
          <div class="row" data-aos="fade-top" data-aos-duration="750">
            <div class="col-md-6">
              <div id="container_sunburst1" class="sunburst" data-aos="fade-right" data-aos-duration="2000">
                <div class="canToolTip canTooltipSunburst_i"></div>
                <h4>Incidence<br/>4.8 million cancer cases</h4>
                <svg></svg>
                <span class="source"><span class="src">Source</span>: Cancer Today,<a href="https://gco.iarc.fr" target="_blank" style="display:inline-block; padding-left: 3px;">https://gco.iarc.fr</a></span>
              </div>
            </div>
            <div class="col-md-6">
              <div id="container_sunburst2" class="sunburst" data-aos="fade-left" data-aos-duration="2000">
                <div class="canToolTip canTooltipSunburst_m"></div>
                <h4>Mortality<br/>3.4 million cancer deaths </h4>
                <svg></svg>
              </div>
            </div>
          </div>
        </div>
      <span class="source source_mobile"><span class="src">Source</span>: Cancer Today,&nbsp;&nbsp;<a href="https://gco.iarc.fr" target="_blank">https://gco.iarc.fr</a></span>
      </div>
      <div class="step step_hidden" data-step-no="1.1">step 1.1</div>
      <div class="step step_hidden" data-step-no="1.2">step 1.2</div>
      <!--<div class="step step_hidden" data-step-no="1.3">step 1.3</div>-->
    </Scrollama>

    <Scrollama
      id="section_2"
      :debug="false"
      :offset="0"
      @step-enter="stepEnter"
    >
      <div class="graphic" slot="graphic">
        <h2 class="story_marker" data-aos="fade-up">Part I: Trends in colorectal cancer incidence and mortality around the world</h2>
        <h3 class="graphic_title" data-aos="fade-up">Changing burden overtime around the world (incidence and mortality trends by country)</h3>
        <p class="desc" data-aos="fade-down">Temporal evolution in colorectal cancer incidence and mortality around the world</p>
        <div id="viz3" data-aos="fade-up" data-aos-duration="750">
        </div>
        <p class="disclaimer">All rights reserved. The designations employed and the presentation of the material in this publication do not imply the expression of any opinion whatsoever on the part of the World Health Organization / International Agency for Research on Cancer concerning the legal status of any country, territory, city or area or of its authorities, or concerning the delimitation of its frontiers or boundaries. Dotted and dashed lines on maps represent approximate borderlines for which there may not yet be full agreement.</p>
        <span class="source"><span class="src">Source</span>: Arnold et al. Gastroenterology. 2020 Jul;159(1):335-349.e15. doi: 10.1053/j.gastro.2020.02.068 - For more info, please visit CI5 <a href="https://ci5.iarc.fr/" target="_blank">https://ci5.iarc.fr/</a></span>
      </div>
      <div class="step step_hidden" data-step-no="2.1">step 2.1</div>
      <!--<div class="step step_hidden" data-step-no="2.2">step 2.2</div>
      <div class="step step_hidden" data-step-no="2.3">step 2.3</div>-->
    </Scrollama>

    <!-- Sunburst -->
    <Scrollama
      id="section_3"
      :debug="false"
      :offset="0.5"
      @step-enter="stepEnter"
    >
      <div class="graphic graphic_third" slot="graphic">
        <!--<h2 class="story_marker" data-aos="fade-up">Part I: Temporal evolution in colorectal cancer incidence and mortality around the world</h2>-->
        <h3 class="graphic_title" data-aos="fade-up">Evolution of colorectal cancer incidence across age group</h3>
        <p class="desc" data-aos="fade-down"></p>
        <div id="viz4" data-aos="fade-up" data-aos-duration="750">
        </div>
        <div class="legend_mobile">
          <ul>
            <li v-for="(legend,l) in legend_trends_mobile">
              <span :style="{backgroundColor:legend.color}" class="marker"></span>{{legend.label}}</li>
          </ul>
        </div>
        <span class="source"><span class="src">Source</span>: Araghi et al. Lancet Gastroenterol Hepatol. 2019 Jul;4(7):511-518. doi: 10.1016/S2468-1253(19)30147-5.</a></span>
        <ul class="legend">
          <li v-for="(age,i) in legend_trends">
            <a v-on:click="updateViz4(age,current_countries)" v-bind:class="[age_group==age?'selected':'']">
              <label :for="'age_'+i">{{ age }}</label>
              <input :id="'age_'+i" type="radio" v-model="age_group" name="age" :value="age">
            </a>
          </li>
        </ul>
      </div>
      
      <div class="step step_third" data-step-no="3.0">
        <div class="story"> <h4 class="title_norway">Norway</h4><br/>Incidence of colon cancer in Norway has steadily increased for all ages and is the highest in most recent years among the seven included high-income countries. While rates have stabilised in those aged below 75 years, much of the overall increase in incidence can be attributed to rises among the 75+ age group.</div>
      </div>
      <div class="step step_third" data-step-no="3.1">
        <div class="story"> <h4 class="title_denmark">Denmark</h4><br/>In Denmark, incidence rates of colon cancer have risen for all ages. This was most pronounced in the youngest age group (<50 years) with an average annual increase of 3.1% in recent years. In contrast, incidence in those aged 50-74 has remained stable.</div>
      </div>
      <div class="step step_third" data-step-no="3.2">
        <div class="story"> <h4 class="title_australia">Australia</h4><br/>In Australia, colon cancer incidence rates have recently fallen, mostly driven by decreases in the 50-74 age group. In those aged below 50 years, rates have increased by 2.9% every year, while rates for the oldest age group (75+) remained stable.</div>
      </div>
      <div class="step step_third" data-step-no="3.3">
        <div class="story"> <h4 class="title_new_zealand">New Zealand</h4><br/>Together with Norway, New Zealand has some of the highest incidence rates of colon cancer among the seven high-income countries included here. Trends are characterised by increases in the younger age group (2.9% every year), strong decreases in those aged 50-74 years (3.4% every year) and stable rates in the oldest age group.</div>
      </div>
      <div class="step step_third" data-step-no="3.4">
        <div class="story"> <h4 class="title_ireland">Ireland</h4><br/>Colon cancer rates in Ireland have remained relatively stable over time, with incidence being among the lowest of the seven countries included here. However, rates in those aged 75+ have risen in most recent years.</div></div>
      <div class="step step_third" data-step-no="3.5">
        <div class="story"> <h4 class="title_canada">Canada</h4><br/>Incidence rates of colon cancer in Canada remain comparatively low and have been decreasing, particularly in the 50-74 and 75+ age groups. Rates in the youngest age group have remained stable.</div>
      </div>
      <div class="step step_third" data-step-no="3.6">
        <div class="story"> <h4 class="title_uk">United Kingdom</h4><br/>In the UK, incidence rates of colon cancer have remained stable in most recent years but trends over time differ largely by age group. Rates in the youngest age group recently rose by 1.8% every year, which is in contrast to the recent decline in incidence among those aged 50-74 and 75+years.</div>
      </div>
    </Scrollama>

    <Scrollama
      id="section_4"
      :debug="false"
      :offset="0"
      @step-enter="stepEnter"
    >
      <div class="graphic graphic_third" slot="graphic">
        <h2 class="story_marker" data-aos="fade-up">Part II: Colorectal cancer and early detection</h2>
        <h3 class="graphic_title" data-aos="fade-up">Stage at diagnosis for patients with colon cancer diagnosed in 2010-2014</h3>
        <p class="desc" data-aos="fade-down"></p>
        <div class="row">
          <div id="viz5" class="col-md-7"></div>
          <div id="viz5_desc" class="col-md-5">
            <!--<p class="story" id="marker-text-5-1"></p>
            <p class="story" id="marker-text-5-2"></p>-->          
            <div id="text-5-1" class="desc">
              More than <span class="selected">1 in 3 colon cancers</span> are diagnosed at an early, <span class="selected">localised stage</span> (except in New Zealand, where this is 1 in 4 cancers) 
            </div>
            <div id="text-5-2" class="desc">
              The proportion of colon cancer cases presenting with <span class="selected">distant</span> disease is relatively similar across countries, ranging from <span class="selected">21.5%</span> in Australia to <span class="selected">28.7%</span> in the UK 
            </div>
          </div>
        </div>
        <span class="source"><span class="src">Source</span>: Araghi et al. Gut. 2020 Jun 1;gutjnl-2020-320625. doi: 10.1136/gutjnl-2020-320625.</span>
      </div>
      <div class="step step_hidden" data-step-no="4.1">4.1</div>
      <div class="step step_hidden" data-step-no="4.2">4.2</div>
      <!--<div class="step step_hidden" data-step-no="4.3">4.3</div>
      <div class="step" data-step-no="4.4">4.4</div>-->
    </Scrollama>

    <Scrollama
      id="section_5"
      :debug="false"
      :offset="0"
      @step-enter="stepEnter"
    >
      <div class="graphic graphic_third" slot="graphic">
        <h2 class="story_marker" data-aos="fade-up">Part III: Colorectal cancer management and care</h2>
        <h3 class="graphic_title" data-aos="fade-up">Survival among patients with colorectal cancer: Evolution over time</h3>
        <p class="desc" data-aos="fade-down"></p>
        <div class="row">
          <div id="viz6" class="col-md-7">
            <div class="viz6" id="viz6-1">
              <h4 data-aos="fade-up">Colon</h4>
            </div>
            <div class="viz6" id="viz6-2">
              <h4 data-aos="fade-up">Rectum</h4>
            </div>
          </div>
          <div id="viz6_desc">
            <div class="desc" id="text-6-1">
              Colon cancer survival has increased in high-income countries over the past 20 years. For example in Denmark 5-year survival increased from <span class="selected selected_yellow">49.1%</span> in <span class="selected selected_yellow">1995-1999</span> to <span class="selected selected2">65.7%</span> in <span class="selected selected2">2010-2014</span>. 
            </div>
            <div class="desc" id="text-6-2">
              Yet, disparities across countries persist with 5-year survival ranging between <span class="selected">58.9%</span> in the <span class="selected">UK</span> to <span class="selected">70.8%</span> in <span class="selected">Australia</span> for colon cancer patients diagnosed in 2010-14. 
            </div>
            <div class="desc" id="text-6-3">
              Patterns are similar for rectal cancer.
            </div>
          </div>
        </div>
        <span class="source"><span class="src">Source</span>: Araghi et al. Gut. 2020 Jun 1;gutjnl-2020-320625. doi: 10.1136/gutjnl-2020-320625.</span>
      </div>
      <div class="step step_hidden" data-step-no="5.1">5.1</div>
      <div class="step step_hidden" data-step-no="5.2">5.2</div>
      <div class="step step_hidden" data-step-no="5.3">5.3</div>
      <!--<div class="step step_hidden" data-step-no="5.4">5.4</div>
      <div class="step" data-step-no="5.6">5.5</div>-->
    </Scrollama>

    <Scrollama
      id="section_6"
      :debug="false"
      :offset="0"
      @step-enter="stepEnter"
    >
      <div class="graphic graphic_thir  d graphic_right" slot="graphic">
        <!--<h2 class="story_marker" data-aos="fade-up">Part III: Colorectal cancer management and care</h2>-->
        <h3 class="graphic_title" data-aos="fade-up">What does the future hold? Future deaths and mortality rates for colorectal cancer</h3>
        <p class="desc" data-aos="fade-down"></p>
        <div class="row">
          <div id="viz7" class="col-md-7"></div>
          <div id="viz7_desc" class="col-md-5">
            <div class="desc"><span id="text1" class="subtext"> While <span class="d_rates">colon and rectal cancer mortality rates</span> are generally decreasing, </span><span id="text2" class="subtext"> <span class="d_num">the number of deaths</span> from the diseases across all included countries* is predicted to <span class="d_num">increase by 60%</span>, when comparing deaths observed in 2013 and the predicted deaths in 2035.</span></div>
            <div class="desc"><span id="text3" class="subtext">This is mainly driven by population growth and ageing.</span></div>
          </div>
        </div>
        <span class="source"><span class="src">* Source</span>: Araghi et al. Gut. 2020 Jun 1;gutjnl-2020-320625. doi: 10.1136/gutjnl-2020-320625.</span>
      </div>
      <div class="step step_hidden" data-step-no="6.1">6.1</div>
      <div class="step step_hidden" data-step-no="6.2">6.2</div>
      <div class="step step_hidden" data-step-no="6.3">6.3</div>
    </Scrollama>
    
  </div>

</template>

<script>

import Vue from 'vue'
import "intersection-observer";
import Scrollama from "vue-scrollama";
var MobileDetect = require('mobile-detect'),
md = new MobileDetect(window.navigator.userAgent);

export default {
  /**
  * Init data properties
  */
  components : {
    Scrollama
  },
  data: () => ({
    intersectionOptions: {
      root: null,
      rootMargin: '0px 0px 0px 0px',
      threshold: [0, 1] // [0.25, 0.75] if you want a 25% offset!
    }, 
    intersectionOptions1b : {
      root: null,
      rootMargin: '185px 0px 0px 0px',
      threshold: [0,1]
    },
    // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API,
    slides : [],
    cars : {} ,
    colors : {
      'inc' : '#383f59' , 
      'mort' : '#d52e86',
      'circle' : '#E50A8C',
      'map_path' : '#6675ab' , 
      'map_circle' : '#ff7b17' ,
      'Australia' : '#F9C449' , 
      'Canada' : '#d6d6d6' ,
      'New Zealand' : '#3C4CAD' , 
      'Denmark' : '#F04393' , 
      'Norway' : '#E8A49C' , 
      'Ireland' : '#7ec46c' , 
      'United Kingdom' : '#5f4db3'
    }, 
    layout : { width_half : 0 , height : 0 },
    currStep: null , 
    currStepProgress: null , 
    legend_trends_mobile : [] , 
    // first version

    width : ( $(window).width() > 1280 ) ? 1280 : $(window).width() , 
    height : 0 , 
    margin : { top: 150 , right: 50, bottom: 150, left: 200 } ,
    waypoints : [] ,
    legend_trends : [] , 
    age_group : 'All ages' , 
    annotation_cpt : 0 , 
    current_country : {} ,
    name : 'Brazil' , 
    country_model : 376 , 
    list_circles : [] , 
    data_ : [] , 
    start_from_beginning : true , 
    data : {
      'viz1' : {
        'inc' : {
          'label' : 'root' , 
          'color' : 'transparent',
          'children' : [
            { 
              'id' : 1 , 
              'label' : 'Incidence' , 
              //'total' : 26.3 , 
              'color' : '#6675ab' , 
              'children' : [
                { 'id': 3 , 'title' : 'Incidence' ,  'label' : 'Colorectum' , 'value' : 10.2 , 'total' : 38.7 , 'color' : '#ff7b17' },
                { 'id': 4 , 'title' : 'Incidence' , 'label' : 'Stomach', 'value' : 5.7 ,  'total' : 21.7 , 'color' : '#d3de16' },
                { 'id': 5 , 'title' : 'Incidence' , 'label' : 'Liver' , 'value' : 4.7 ,  'total' : 17.8 , 'color' : '#e8a39c' },
                { 'id': 6 , 'title' : 'Incidence'  , 'label' : 'Oesophagus' , 'value' : 3.2 , 'total' : 12.2 , 'color' : '#0191b6' },
                { 'id': 7 , 'title' : 'Incidence'  , 'label' : 'Pancreas' , 'value' : 2.5 , 'total' : 9.6 , 'color' : '#f9d80d' }
              ] 
            } ,
            { 
              'id' : 1.1 , 
              'title' : 'Incidence',
              'label' : 'Other cancers' , 
              'value' : 73.7,
              'color' : '#fbfbfb'
            }
          ] 
        },
        'mort' : {
          'label' : 'root' , 
          'color' : 'transparent',
          'children' : [
            { 
              'id' : 2 , 
              'label' : 'Mortality' , 
              //'total' : 26.3 , 
              'color' : '#d52e86' , 
              'children' : [
                { 'id': 8 , 'title' : 'Mortality' , 'label' : 'Colorectum' , 'value' : 9.2 , 'total' : 38.7 , 'color' : '#ff7b17' },
                { 'id': 9 , 'title' : 'Mortality', 'label' : 'Stomach', 'value' : 8.2 ,  'total' : 21.7 , 'color' : '#d3de16' },
                { 'id': 10 , 'title' : 'Mortality', 'label' : 'Liver' , 'value' : 8.2 ,  'total' : 17.8 , 'color' : '#e8a39c' },
                { 'id': 11 , 'title' : 'Mortality', 'label' : 'Oesophagus' , 'value' : 5.3 , 'total' : 12.2 , 'color' : '#0191b6' },
                { 'id': 12 , 'title' : 'Mortality', 'label' : 'Pancreas' , 'value' : 4.5 , 'total' : 9.6 , 'color' : '#f9d80d' }
              ] } 
            ,
            { 
              'id' : 2.1 , 
              'title' : 'Mortality',
              'label' : 'Other cancers' , 
              'value' : 64.6,
              'color' : '#fbfbfb'
            }
          ]
        }
      } , 
      'viz2' : [] , 
      'viz3' : ['USA','CAN','DNK','NLD','GBR','AUT','SVK','ITA','ESP','BLR','CHN','HKG','KOR','PHL','BRA','ECU','CRI','COL','UGA','ZAF','ISR','KWT','TUR','THAI','AUS','NZL'],
      'regions' : [
        { 'label' : 'North America' , 'code' : 'na' } , 
        { 'label' : 'North-West Europe' , 'code' : 'nwe' } , 
        { 'label' : 'South-East Europe' , 'code' : 'see' } , 
        { 'label' : 'East Asia' , 'code' : 'ea' } , 
        { 'label' : 'Africa' , 'code' : 'a' } , 
        { 'label' : 'Sout-West Asia' , 'code' : 'swa' } , 
        { 'label' : 'Oceania' , 'code' : 'o' } , 
      ] , 

      /*
        Australia Canada  Denmark Ireland New Zealand Norway  UK
Localised 37,7  38  40,8  37  25,4  43,7  37,7
Regional  40,8  39,2  32,8  37,5  46,5  28,3  33,6
Distant 21,5  22,8  26,4  25,5  28,1  28  28,7
      */
      'viz5' : [
        {   
          'id' : 1 , 
          'label' : 'Australia' , 
          'values' : [
            { 'stage_type' : 'Localised' , 'value' : 37.7 , 'color' : '#d52e86' },
            { 'stage_type' : 'Regional' , 'value' : 40.8 , 'color' : '#494BE1'},
            { 'stage_type' : 'Distant', 'value' : 21.5  , 'color' : '#009EFE'}
          ]
        },
        {   
          'id' : 2 , 
          'label' : 'Canada', 
          'values' : [
            { 'stage_type' : 'Localised' , 'value' : 38 , 'color' : '#d52e86'},
            { 'stage_type' : 'Regional' , 'value' : 39.2 , 'color' : '#494BE1'},
            { 'stage_type' : 'Distant' , 'value' : 22.8  , 'color' : '#009EFE'}
          ]
        },
        { 
          'id' : 1 , 
          'label' : 'Denmark' , 
          'values' : [
            { 'stage_type' : 'Localised' , 'value' : 40.8 , 'color' : '#d52e86'}, 
            { 'stage_type' : 'Regional' , 'value' : 32.8 , 'color' : '#494BE1'},
            { 'stage_type' : 'Distant' , 'value' : 26.4  , 'color' : '#009EFE'}
          ]
        },
        { 
          'id' : 1 , 
          'label' : 'Ireland' , 
          'values' : [
            { 'stage_type' : 'Localised' , 'value' : 37 , 'color' : '#d52e86'}, 
            { 'stage_type' : 'Regional' , 'value' : 37.5 , 'color' : '#494BE1'},
            { 'stage_type' : 'Distant' , 'value' : 25.5  , 'color' : '#009EFE'}
          ]
        },
        { 
          'id' : 1 , 
          'label' : 'New Zealand' , 
          'values' : [
            { 'stage_type' : 'Localised' , 'value' : 25.4 , 'color' : '#d52e86'},
            { 'stage_type' : 'Regional' , 'value' : 46.5 , 'color' : '#494BE1'},
            { 'stage_type' : 'Distant' , 'value' : 28.1  , 'color' : '#009EFE'}
          ]
        },
        { 
          'id' : 1 , 
          'label' : 'Norway' , 
          'values' : [
            { 'stage_type' : 'Localised' , 'value' : 43.7 , 'color' : '#d52e86'},
            { 'stage_type' : 'Regional' , 'value' : 28.3 , 'color' : '#494BE1'},
            { 'stage_type' : 'Distant' , 'value' : 28  , 'color' : '#009EFE'}
          ]
        },
        { 
          'id' : 1 , 
          'label' : 'UK' , 
          'values' : [
            { 'stage_type' : 'Localised' , 'value' : 37.7 , 'color' : '#d52e86'}, 
            { 'stage_type' : 'Regional' , 'value' : 33.6 , 'color' : '#494BE1'},
            { 'stage_type' : 'Distant' , 'value' : 28.7  , 'color' : '#009EFE'}
          ]
        }
      ] , 
      'viz6' : [{"cancer":"colon","period":"1995-1999","label":"Australia","value":59.6},{"cancer":"colon","period":"1995-1999","label":"Canada","value":57.9},{"cancer":"colon","period":"1995-1999","label":"Denmark","value":49.1},{"cancer":"colon","period":"1995-1999","label":"Ireland","value":50},{"cancer":"colon","period":"1995-1999","label":"New Zealand","value":59.3},{"cancer":"colon","period":"1995-1999","label":"Norway","value":55.7},{"cancer":"colon","period":"1995-1999","label":"UK","value":47},{"cancer":"colon","period":"2000-2004","label":"Australia","value":63.5},{"cancer":"colon","period":"2000-2004","label":"Canada","value":61.3},{"cancer":"colon","period":"2000-2004","label":"Denmark","value":53.2},{"cancer":"colon","period":"2000-2004","label":"Ireland","value":52.7},{"cancer":"colon","period":"2000-2004","label":"New Zealand","value":60.3},{"cancer":"colon","period":"2000-2004","label":"Norway","value":58},{"cancer":"colon","period":"2000-2004","label":"UK","value":51},{"cancer":"colon","period":"2005-2009","label":"Australia","value":67.1},{"cancer":"colon","period":"2005-2009","label":"Canada","value":65.4},{"cancer":"colon","period":"2005-2009","label":"Denmark","value":57.5},{"cancer":"colon","period":"2005-2009","label":"Ireland","value":58},{"cancer":"colon","period":"2005-2009","label":"New Zealand","value":61.6},{"cancer":"colon","period":"2005-2009","label":"Norway","value":62.2},{"cancer":"colon","period":"2005-2009","label":"UK","value":55.3},{"cancer":"colon","period":"2010-2014","label":"Australia","value":70.8},{"cancer":"colon","period":"2010-2014","label":"Canada","value":66.8},{"cancer":"colon","period":"2010-2014","label":"Denmark","value":65.7},{"cancer":"colon","period":"2010-2014","label":"Ireland","value":61.8},{"cancer":"colon","period":"2010-2014","label":"New Zealand","value":62.1},{"cancer":"colon","period":"2010-2014","label":"Norway","value":65.4},{"cancer":"colon","period":"2010-2014","label":"UK","value":58.9},{"cancer":"rectum","period":"1995-1999","label":"Australia","value":59.1},{"cancer":"rectum","period":"1995-1999","label":"Canada","value":57.5},{"cancer":"rectum","period":"1995-1999","label":"Denmark","value":48.1},{"cancer":"rectum","period":"1995-1999","label":"Ireland","value":47.6},{"cancer":"rectum","period":"1995-1999","label":"New Zealand","value":56.3},{"cancer":"rectum","period":"1995-1999","label":"Norway","value":57.3},{"cancer":"rectum","period":"1995-1999","label":"UK","value":47.8},{"cancer":"rectum","period":"2000-2004","label":"Australia","value":64.1},{"cancer":"rectum","period":"2000-2004","label":"Canada","value":61.6},{"cancer":"rectum","period":"2000-2004","label":"Denmark","value":54},{"cancer":"rectum","period":"2000-2004","label":"Ireland","value":51},{"cancer":"rectum","period":"2000-2004","label":"New Zealand","value":59.7},{"cancer":"rectum","period":"2000-2004","label":"Norway","value":61.5},{"cancer":"rectum","period":"2000-2004","label":"UK","value":53},{"cancer":"rectum","period":"2005-2009","label":"Australia","value":68.5},{"cancer":"rectum","period":"2005-2009","label":"Canada","value":65.4},{"cancer":"rectum","period":"2005-2009","label":"Denmark","value":60.7},{"cancer":"rectum","period":"2005-2009","label":"Ireland","value":57.1},{"cancer":"rectum","period":"2005-2009","label":"New Zealand","value":62.4},{"cancer":"rectum","period":"2005-2009","label":"Norway","value":65.4},{"cancer":"rectum","period":"2005-2009","label":"UK","value":57},{"cancer":"rectum","period":"2010-2014","label":"Australia","value":70.8},{"cancer":"rectum","period":"2010-2014","label":"Canada","value":67},{"cancer":"rectum","period":"2010-2014","label":"Denmark","value":69.1},{"cancer":"rectum","period":"2010-2014","label":"Ireland","value":62.4},{"cancer":"rectum","period":"2010-2014","label":"New Zealand","value":65.4},{"cancer":"rectum","period":"2010-2014","label":"Norway","value":68.8},{"cancer":"rectum","period":"2010-2014","label":"UK","value":62.1}]
      ,
      'viz7' : {
        'colon' : [{"value":121884,"metric":"cases","year":1989},{"value":139849,"metric":"cases","year":1990},{"value":140792,"metric":"cases","year":1991},{"value":144867,"metric":"cases","year":1992},{"value":146783,"metric":"cases","year":1993},{"value":148839,"metric":"cases","year":1994},{"value":149627,"metric":"cases","year":1995},{"value":150100,"metric":"cases","year":1996},{"value":150483,"metric":"cases","year":1997},{"value":151312,"metric":"cases","year":1998},{"value":152007,"metric":"cases","year":1999},{"value":152947,"metric":"cases","year":2000},{"value":154254,"metric":"cases","year":2001},{"value":156566,"metric":"cases","year":2002},{"value":157824,"metric":"cases","year":2003},{"value":157205,"metric":"cases","year":2004},{"value":157377,"metric":"cases","year":2005},{"value":156354,"metric":"cases","year":2006},{"value":157883,"metric":"cases","year":2007},{"value":158430,"metric":"cases","year":2008},{"value":156524,"metric":"cases","year":2009},{"value":157384,"metric":"cases","year":2010},{"value":156906,"metric":"cases","year":2011},{"value":159701,"metric":"cases","year":2012},{"value":158816,"metric":"cases","year":2013},{"value":187361,"metric":"cases","year":2015},{"value":197886,"metric":"cases","year":2020},{"value":"213134,6","metric":"cases","year":2025},{"value":"234255,2","metric":"cases","year":2030},{"value":"254198,4","metric":"cases","year":2035},{"value":"8,13958508","metric":"asr","year":1989},{"value":"8,129371514","metric":"asr","year":1990},{"value":"8,297631376","metric":"asr","year":1991},{"value":"8,349438617","metric":"asr","year":1992},{"value":"8,387990529","metric":"asr","year":1993},{"value":"8,460255759","metric":"asr","year":1994},{"value":"8,411955266","metric":"asr","year":1995},{"value":"8,45225751","metric":"asr","year":1996},{"value":"8,331459735","metric":"asr","year":1997},{"value":"8,242380808","metric":"asr","year":1998},{"value":"8,278443854","metric":"asr","year":1999},{"value":"8,212516544","metric":"asr","year":2000},{"value":"8,169352509","metric":"asr","year":2001},{"value":"8,19292513","metric":"asr","year":2002},{"value":"8,035553388","metric":"asr","year":2003},{"value":"7,872660555","metric":"asr","year":2004},{"value":"7,810614225","metric":"asr","year":2005},{"value":"7,686128155","metric":"asr","year":2006},{"value":"7,66028284","metric":"asr","year":2007},{"value":"7,585404319","metric":"asr","year":2008},{"value":"7,512156165","metric":"asr","year":2009},{"value":"7,360813563","metric":"asr","year":2010},{"value":"7,14899437","metric":"asr","year":2011},{"value":"7,290665894","metric":"asr","year":2012},{"value":"7,101838298","metric":"asr","year":2013},{"value":"6,934204764","metric":"asr","year":2015},{"value":"6,726715888","metric":"asr","year":2020},{"value":"6,590667215","metric":"asr","year":2025},{"value":"6,542747313","metric":"asr","year":2030},{"value":"6,527871397","metric":"asr","year":2035}],
        'rectum' : [{"cases":48487,"metric":"cases","year":1989},{"cases":56836,"metric":"cases","year":1990},{"cases":57181,"metric":"cases","year":1991},{"cases":58539,"metric":"cases","year":1992},{"cases":58841,"metric":"cases","year":1993},{"cases":58202,"metric":"cases","year":1994},{"cases":59524,"metric":"cases","year":1995},{"cases":60365,"metric":"cases","year":1996},{"cases":59943,"metric":"cases","year":1997},{"cases":60959,"metric":"cases","year":1998},{"cases":61217,"metric":"cases","year":1999},{"cases":61689,"metric":"cases","year":2000},{"cases":62148,"metric":"cases","year":2001},{"cases":64048,"metric":"cases","year":2002},{"cases":65072,"metric":"cases","year":2003},{"cases":66423,"metric":"cases","year":2004},{"cases":66249,"metric":"cases","year":2005},{"cases":67565,"metric":"cases","year":2006},{"cases":67165,"metric":"cases","year":2007},{"cases":68828,"metric":"cases","year":2008},{"cases":68684,"metric":"cases","year":2009},{"cases":70703,"metric":"cases","year":2010},{"cases":70728,"metric":"cases","year":2011},{"cases":72480,"metric":"cases","year":2012},{"cases":72647,"metric":"cases","year":2013},{"cases":"85624,2","metric":"cases","year":2015},{"cases":93767,"metric":"cases","year":2020},{"cases":"103088,8","metric":"cases","year":2025},{"cases":"114294,8","metric":"cases","year":2030},{"cases":"124646,8","metric":"cases","year":2035},{"cases":"4,587248708","metric":"asr","year":1989},{"cases":"4,494923029","metric":"asr","year":1990},{"cases":"4,481261212","metric":"asr","year":1991},{"cases":"4,650837518","metric":"asr","year":1992},{"cases":"4,633525373","metric":"asr","year":1993},{"cases":"4,593981944","metric":"asr","year":1994},{"cases":"4,572892555","metric":"asr","year":1995},{"cases":"4,574922616","metric":"asr","year":1996},{"cases":"4,48430356","metric":"asr","year":1997},{"cases":"4,378739611","metric":"asr","year":1998},{"cases":"4,401762211","metric":"asr","year":1999},{"cases":"4,310904765","metric":"asr","year":2000},{"cases":"4,281901291","metric":"asr","year":2001},{"cases":"4,301288498","metric":"asr","year":2002},{"cases":"4,263483076","metric":"asr","year":2003},{"cases":"4,229018248","metric":"asr","year":2004},{"cases":"4,131804765","metric":"asr","year":2005},{"cases":"4,108855788","metric":"asr","year":2006},{"cases":"4,034105174","metric":"asr","year":2007},{"cases":"3,990127912","metric":"asr","year":2008},{"cases":"3,977503866","metric":"asr","year":2009},{"cases":"3,935988698","metric":"asr","year":2010},{"cases":"3,869923296","metric":"asr","year":2011},{"cases":"3,914057912","metric":"asr","year":2012},{"cases":"3,909157073","metric":"asr","year":2013},{"cases":"3,81687607","metric":"asr","year":2015},{"cases":"3,749354952","metric":"asr","year":2020},{"cases":"3,717670984","metric":"asr","year":2025},{"cases":"3,724355802","metric":"asr","year":2030},{"cases":"3,736110515","metric":"asr","year":2035}]
      } 
    },
    viz6 : [] , 
    oTrend4 : {} ,
    oViz5 : {} ,
    oViz6 : {} , 
    current_countries : []
  }),
  /**
  * Event created
  */
  created(){
    //console.info("created",$(window).scrollTop()) ; 
    if ( $(window).scrollTop() != 0 ) $(window).scrollTop(0) ; 
  },
  /**
  * Event mounted
  */
  mounted(){
    
    console.info("mounted",$(window).scrollTop()) ; 
    if ( $(window).scrollTop() != 0 ) 
    {
      this.start_from_beginning = false ; 
      setTimeout(() => {
        console.info("GO TO TOP !")
        $(window).scrollTop(0) ;
        this.start_from_beginning = true ; 
      }, 500)
      
    }
    this.margin_bars  = this.margin ;
    this.height_bars  = $(window).height() - this.margin_bars.top - this.margin_bars.bottom ; 
    this.width_bars   = this.width - this.margin_bars.left - this.margin_bars.right ; 

    let uri     = window.location.search.replace("?",""); 
    let data_params = uri.split('=') ; 
    let params  = {};
    params.show_steps = new Boolean( data_params[1] ) ; 

    let scripts = [
      //'https://d3js.org/d3.v5.min.js',
      //process.env.VUE_APP_GRAPHICS_HOST+'/libs/CanGraph.js',
      //process.env.VUE_APP_GRAPHICS_HOST+'/libs/CanMapGraph.js',
      //process.env.VUE_APP_GRAPHICS_HOST+'/libs/d3-annotation.js'
    ] 
    var tag_script 
    for ( var s in scripts ){
      // eslint-disable-next-line
      var tag_script = document.createElement("script")
      tag_script.type  = "text/javascript"
      tag_script.src   = scripts[s]
      tag_script.async = true
      // tag_script = loadAsynScript(scripts[s]) ; 
      this.$el.appendChild(tag_script)
    }

    // Animate On Scroll Library init
    AOS.init({
      once: true
    });

    // launch gauges for slide 1
    this.launchVizSunburst();

    this.launchVizMap(); 

    this.launchTrendsVizCountries();

    this.launchVizDoubleBars() ; 

    this.launchMultiBars('#viz6-1',0);

    this.updateVizMultiBars('#viz6-1',0);

    this.launchMultiBars('#viz6-2',1);

    this.launchViz7();

    if ( params.show_steps == true ) $('.step').addClass('step_show') ; 

  },
  /**
  * Methods
  */
  methods: {
    
    //var csv is the CSV file with headers
    csvJSON : function (csv){

      var parsed = d3.csvParse(csv);
      return parsed ; 
    
    }, 
    /**
    * onEnter step
    */
    stepEnter : function({element, index, direction}){

      let step = $(element).attr('data-step-no') ; 
      // this.currStep = element.dataset.stepNo ; 

      console.info("step",direction,parseFloat(step),this.start_from_beginning,this.dataset_trends) ; 
      //this.current_countries = ['Norway'] ;

      if ( this.start_from_beginning == false ) return ; 

      // ensuring dataset trends is loaded
      if ( this.dataset_trends == undefined ) return ; 

      switch( step )
      {
        case '1.1' :
          $('g.slice.hidden_slice,div.sunburst_legend').animate({opacity:1},250) ;  
          break ;

        /*case '1.2' :
          //$('g.slice.hidden_slice').animate({opacity:1},1000) ; 
          break ;*/ 

        case '3.0':
          this.current_countries.push('Norway');   
          this.updateViz4(this.age_group,this.current_countries) ;  
          break ;

        case '3.1':
          this.current_countries.push('Denmark');   
          this.updateViz4(this.age_group,this.current_countries) ;  
          break ; 

        case '3.2': 
          this.current_countries.push('Australia')
          this.updateViz4(this.age_group,this.current_countries) ;  
          break ; 
        case '3.3':
          this.current_countries.push('New Zealand')
          this.updateViz4(this.age_group,this.current_countries) ;  
          break ; 
        case '3.4':
          this.current_countries.push('Ireland')
          this.updateViz4(this.age_group,this.current_countries) ;  
          break ; 
        case '3.5':
          this.current_countries.push('Canada')
          this.updateViz4(this.age_group,this.current_countries) ;  
          break ; 
        case '3.6':
          this.current_countries.push('United Kingdom')
          this.updateViz4(this.age_group,this.current_countries) ;  
          break ; 
        case '3.7':

          break ;

        case '4.0' : 
          //this.updateVizDoulbeBars();
          break ;
        case '4.1' :
          $("#text-5-1").fadeIn('slow') ;
          d3.selectAll('#viz5 rect.poly')
            .transition().duration(1000)
              .style('opacity',(b)=>{
                return ((b.stage_type=="Localised")?1:0.2);
              })
            ;
            d3.selectAll('#viz5 text.text')
            .transition().duration(1000)
              .style('opacity',(b)=>{
                return ((b.stage_type=="Localised")?1:0.2);
              })
            ;
          break ; 
        case '4.2':
          $("#text-5-2").fadeIn('slow') ;
          d3.selectAll('#viz5 rect.poly')
            .transition().duration(1000)
              .style('opacity',(b)=>{
                return ((b.stage_type=="Distant")?1:0.2);
              })
            ;
          d3.selectAll('#viz5 text.text')
          .transition().duration(1000)
            .style('opacity',(b)=>{
              return ((b.stage_type=="Distant")?1:0.2);
            })
          ;
          break; 

        case '5.0':
          // this.updateVizMultiBars('#viz6-1',0)
          break ; 

        case '5.1':
          $("#text-6-1").fadeIn('slow') ;
          d3.selectAll('#viz6-1 svg rect.bar')
          .transition().duration(1000)
            .style('opacity',(b)=>{
              return ((b.label=="Denmark" && (b.period=="1995-1999"||b.period=="2010-2014"))?1:0.2);
            })
          ;
          d3.selectAll('#viz6-1 svg text.txt_bar')
          .transition().duration(1000)
            .style('opacity',(b)=>{
              return ((b.label=="Denmark" && (b.period=="1995-1999"||b.period=="2010-2014"))?1:0);
            })
            .attr('y',(b)=>{
              return ((b.label=="Denmark" && (b.period=="1995-1999"||b.period=="2010-2014"))?this.oViz6.y(b.value)-5:this.oViz6.y(b.value)+20);
            })
          ;
          break ; 

        case '5.2':
          $("#text-6-2").fadeIn('slow') ;
            d3.selectAll('#viz6-1 svg rect.bar')
            .transition().duration(1000)
              .style('opacity',(b)=>{
                return (((b.label=="UK"||b.label=="Australia")&&b.period=="2010-2014")?1:0.2);
              })
            ;
            d3.selectAll('#viz6-1 svg text.txt_bar')
            .transition().duration(1000)
              .style('opacity',(b)=>{
                return (((b.label=="UK" ||b.label=="Australia")&&b.period=="2010-2014")?1:0);
              })
              .attr('y',(b)=>{
                return (((b.label=="UK" ||b.label=="Australia")&&b.period=="2010-2014")?this.oViz6.y(b.value)-5:this.oViz6.y(b.value)+20);
              })
            ;
          break ; 

        case '5.3':
          $("#text-6-3,#viz6-2").fadeIn('slow') ;
          $("#viz6-2,#viz6-2 h4").css({opacity:1});
            
          setTimeout(() => {
            // Todo...
            this.updateVizMultiBars('#viz6-2',1) ;  
            d3.selectAll('#viz6-1 svg rect.bar')
              .transition().duration(1000).style("opacity",1) ; 
            d3.selectAll('#viz6-1 svg text.txt_bar')
              .transition().duration(1000).style("opacity",0) ;

          }, 250 ) ;
          break ; 

        case '6.1':
          $('span.subtext#text1').fadeIn();
          $('g.annotations_colon').show();
          $('.group_lines').show();
          break ; 

        case '6.2':
          this.updateViz7Lines1();
          $('span.subtext#text2').fadeIn();
          $('g.annotations_rectum').show();
          $('span.subtext#text3').fadeIn();

          // hide second list of g text
          $('g.annotations_rectum g.annotation:nth-child(2) text.annotation-note-title tspan').css('opacity',0);
          $('g.annotations_colon g.annotation:nth-child(2) text.annotation-note-title tspan').css('opacity',0);
          break ;

        case '6.3':
          // this.updateViz7Annotations();
          $('span.subtext#text3').fadeIn();
          break ;  
      }
    } , 

    /**
    * Double sunburst
    * @param (no param)
    * @return (no return)
    */
    launchVizSunburst : function(){

      let sunburst_width = ( this.width - 200 ) /2 ; 
      let sunburst_height = $(window).height()/1.5 ; 

      if ( $(window).width() <= 1280 ) sunburst_width = sunburst_width - 150 ; 
      else if ( $(window).width() <= 1440 ) sunburst_width = sunburst_width - 100 ; 

      // console.info("$(window).height()/3 sunburst",sunburst_width,$(window).height()/3) ; 

      let sunburst_conf1 = { 
          'type' : 'sunburst' , 
          'title' : 'A sunburst',
          'id' : 'sunburst1' ,
          'width_container' : $(window).width()/2,
          'width' : ( md.mobile() != null) ? $(window).width()/2 : sunburst_width  , 
          'height' : ( md.mobile() != null) ? $(window).height()/3.5 : sunburst_height ,
          'radius' : ( md.mobile() != null) ?  $(window).height()/3.5 : this.height   , 
          'container' : '#container_sunburst1',   
          'data'      : {
              'format' : 'json',
              'src'  : this.data.viz1
          } , 
          'chart' : {
            'key_data_value' : 'total' , 
            'sub_array' : null , 
            'label_value' : 'Number of cases' , 
            'data_legend' : [] , 
            'paddingTop' : 30 , 
            'show_percentage' : true , 
            'copyright' : false 
          },
          'title'     : ''
      }

      let chart1  = new CanChart( sunburst_conf1 ).render() ;
      chart1.vizInstance.loadSunBurstData(this.data.viz1.inc);

      let colorScale = d3.scaleOrdinal()
        .range(['#FFD806','#008001','#F3A655','#DC1441','#940009','#cccccc'])
        .domain(['Colorectum','Stomach','Liver','Esophagus','Pancreas','Other cancers']) ; 

      this.viz1 = d3.select('svg#sunburst1') ; 

      let sunburst_conf2 = clone_var( sunburst_conf1 ) ; 
      sunburst_conf2.id = 'sunburst2' ; 
      sunburst_conf2.container = '#container_sunburst2' ; 
      let chart2  = new CanChart( sunburst_conf2 ).render() ;
      chart2.vizInstance.loadSunBurstData(this.data.viz1.mort);
      
      this.viz1_1 = d3.select('svg#sunburst2') ; 

      // build fixed legends
      let legend_left = this.data.viz1.inc.children[0].children
      legend_left.forEach( (legend)=>{
        $('#container_sunburst1').append(`<div class="sunburst_legend" id="sunburst_legend_${legend.id}">${legend.label}</div>`)
      })

      let legend_right = this.data.viz1.mort.children[0].children
      legend_right.forEach( (legend)=>{
        $('#container_sunburst2').append(`<div class="sunburst_legend" id="sunburst_legend_${legend.id}">${legend.label}</div>`)
      })

      // specify width 
      $('#container_sunburst1,#container_sunburst2').addClass(`window_${$(window).width()}`) ; 

      // rebase mid title
      $('#container_sunburst1 h4,#container_sunburst2 h4').css({
        'top':(sunburst_width/2)-80,
        'margin-top':( md.mobile() != null) ? 0 : 45,
        'left':( md.mobile() != null) ? 0 : 25
      })

      let right_sunburst_width = sunburst_width ; 
      if ( $(window).width() <= 1440 )
      {
        right_sunburst_width = right_sunburst_width-200 ; 
      }

      /*
      // specific legend 
      $('#sunburst_legend_3').css({'right':right_sunburst_width/2.5,'top':0}); 
      $('#sunburst_legend_4').css({'right':right_sunburst_width/4.5,'top':sunburst_width/8}); 
      $('#sunburst_legend_5').css({'right':right_sunburst_width/5.5,'top':sunburst_width/4}); 
      $('#sunburst_legend_6').css({'right':10,'top':right_sunburst_width/2.5}); 
      $('#sunburst_legend_7').css({'right':35,'top':right_sunburst_width/2}); 

      $('#sunburst_legend_8').css({'right':right_sunburst_width/2.5,'top':0}); 
      $('#sunburst_legend_9').css({'right':right_sunburst_width/4.5,'top':sunburst_width/8}); 
      $('#sunburst_legend_10').css({'right':right_sunburst_width/7.5,'top':sunburst_width/3}); 
      $('#sunburst_legend_11').css({'right':10,'top':right_sunburst_width/1.7}); 
      $('#sunburst_legend_12').css({'right':60,'top':right_sunburst_width/1.3 });*/
      
    }, 

    /**
    * Launch viz map
    * @param (no parram)
    */
    launchVizMap : function(){

      fetch( process.env.VUE_APP_GRAPHICS_HOST_LOCAL + '/data/geojson/world-general.topojson').then( this.initFullMap )

    } , 

    initFullMap : function(  response  ){

      this.visualizationWrapper = d3.select('#viz3');

      this.visualizationWrapper.append("div")
      .attr("class", "canTooltip canTooltipMap")
      .style("opacity", 0)

      response.json().then( ( polygons ) => {
         
        // console.info("polygons",polygons) ; 

        // this.polygons = polygons ;
        this.polygons = polygons.objects['general']  ;
        
        // console.info("$(window).height()/1.5",$(window).height()/1.5)

        let map_height = $(window).height()/1.4 ; 
        //console.info("map_height",map_height);
        let scale = map_height / 2.8 ; 
        let ratio = 1 ; 
        let natural_earth = d3.geoNaturalEarth().scale( scale ).translate( [600,map_height/1.8] ) ; 
        if ( md.mobile() != null )
        {
          natural_earth = d3.geoNaturalEarth().scale( 80 ).translate( [190,250] ) ; 
        }

        this.projections = {
          //'mercator' : d3.geoMercator().scale( 1000 ).translate( [ 500 ,1850] ), 
          'natural_earth' : natural_earth ,
          //'globe' : d3.geoOrthographic().scale(1100).rotate([100,0,0]).translate([this.width/2, this.height/2]).clipAngle(200) 
        } ; 

        this.projection = this.projections[ 'natural_earth' ] ;
        this.map_path   = d3.geoPath().projection( this.projection ) ;

        // nordics regions
        this.svg = this.visualizationWrapper.append('svg')
          .attr('id','map')
          .attr('class','map')
          .attr('width',this.width) // width/1.5
          .attr('height',map_height)
          .append('g')
          .attr('class','map_group')
            ; 

            this.svg_poly = d3.selectAll('svg#map')
          .append('g')
          .attr('class','map_poly')
            ; 

            this.svg_lines = d3.selectAll('svg#map')
          .append('g')
          .attr('class','map_lines')
            ; 

            // console.info("this.polygons",this.polygons ) ; 

            this.svg.selectAll('path')
          .data( topojson.object( polygons, polygons.objects['general']).geometries )
          .enter()
          .append('path')
          .attr('class','country')
          .attr('id',(d)=>{ 
            // console.info("d",d) ; 
            return "path_"+d.properties.ISO_3_CODE ; 
          })
          .attr('d', this.map_path )
          .attr("fill",(d)=>{
            //return '#ffffff' ; 
            return ( this.data.viz3.includes(d.properties.ISO_3_CODE ) == true ) ? this.colors.map_path : '#ffffff'
          })
          .attr("stroke",(d)=>{
            return ( this.data.viz3.includes(d.properties.ISO_3_CODE ) == true ) ? this.colors.map_path : '#ffffff'
          })
          .attr("stroke-width","0.5px")
          .on("click",(d)=>{
            if( this.data.viz3.includes(d.properties.ISO_3_CODE ) == true ) this.openOverlay
          })

        this.svg_poly.selectAll("path")
          .data( topojson.object( polygons , polygons.objects.maskpoly_general ).geometries )
          .enter()
          .append("path")
          .attr("d", this.map_path )
          .attr('class',(p)=>{
            // console.info("p",p)
            let class_ = (p.properties!=undefined)?slugify(p.properties.AREA):'';
            return `poly ${class_}` ; 
          })
          .style('fill','#383f59')
          .style('stroke','transparent')  
          .style('stroke-dasharray',0)  
          .style('stroke-width', '0px' )
          .append("title").text((d)=> d.properties.AREA)

        this.svg_lines.selectAll("path")
          .data( topojson.object( polygons , polygons.objects.maskline_general ).geometries )
          .enter()
          .append("path")
          .attr("d", this.map_path )
          .attr('class',(d)=>{
            //console.info("d.properties.ID",d.properties) ; 
            return 'line lines-'+d.properties.ID+' '+d.properties.class
          })
          .style('fill','none')
          .style('stroke',(d)=>{
            return (d.properties.COUNTRY=='Border')?'#ffffff':'#000000'
          })
          .style('stroke-width','0.5px')
          .append("title").text((d)=>d.properties.COUNTRY)

        this.svg.selectAll('circle')
        .data( topojson.object( polygons, polygons.objects['general']).geometries )
        //.data( this.polygons.features )
        .enter()
        .append('circle')
        .attr("class","country")
        .style('fill',this.colors.map_circle)
        .style('stroke',this.colors.map_path)
        .attr("r",(d)=>{
          let circle = 0 ; 
          if (  this.data.viz3.includes(d.properties.ISO_3_CODE ) == true  )
          {
            this.list_circles.push(d.properties) ; 
            circle = 5 ; 
          } 
          return circle ; 
        })
        .attr("transform", (d)=> { 
          var centroid = this.map_path.centroid(d) ; 
          return "translate(" + ( centroid[0] ) + "," + centroid[1]+ ")"; 
        })
        .on("mousemove",function(d){
          d3.selectAll('circle.country').style('opacity',0.2) ; 
          d3.select(this).style('opacity',1) ; 
          
          let adjust = { x : 80 , y : 85 } ;  
          let info = { title : d.properties.CNTRY_TERR , value : 'value' , label : 'label' } ;  
          console.info("d",d);
          let tooltipType = "canTooltipMap" ; 
          //toolTipOn(info,tooltipType,adjust) ; 
        })
        .on("mouseout",function(d){
          d3.selectAll('circle.country').style('opacity',1) ; 
          //toolTipOut() ; 
        })
        .on("click",this.openOverlay)

        // put legend map

        let colorScale_Map = d3.scaleOrdinal()
          .range([this.colors.map_path,'#fff','#ccc'])
          .domain(['Country with data','No data','Not applicable']) ; 

        let leg_left = ($(window).width() <= 1280 ) ? 80 : 20 ; 

        if ( ( md.mobile() != null) ) leg_left = 10 ; 
        let trans_leg_ordinal = `${map_height-(( md.mobile() != null)?120:100)}` ; 

        this.svg.append("g")
          .attr("class", "legendOrdinal legendOrdinalMap")
          .attr("transform", `translate(${leg_left},${trans_leg_ordinal})`);

        let legendMap = d3.legendColor()
          .shapeWidth(( md.mobile() != null)?15:30)
          .shapeHeight(( md.mobile() != null)?10:20)
          .shapePadding(( md.mobile() != null)?4:10)
          .scale(colorScale_Map);

        this.svg.select(".legendOrdinal")
          .call(legendMap);

        this.svg.select(".legendOrdinalMap g.cell:first-child")
          .append('circle')
          .attr('r',5)
          .attr('cx',((md.mobile() != null)?15:30)/2)
          .attr('cy',((md.mobile() != null)?10:20)/2)
          .style('fill','#ff7b17')

        // prepare overlay line
        this.launchVizMap_b() ; 

        setTimeout(() => {
          // fetch( process.env.VUE_APP_GRAPHICS_HOST_LOCAL + "/data/trends-by-country.csv" ).then( (response) => {
          fetch( process.env.VUE_APP_GRAPHICS_HOST_LOCAL + "/data/Figure2_trend_colorectum_inc_mort.csv" ).then( (response) => {          
            response.text().then( (data) => { 

              let data_ = this.csvJSON(data) ; // 
              this.data_ = data_ ; 

              // console.info("this.data_",this.data_) ; 
              let data_init = this.data_.filter( f => { return f.country_code == this.country_model }) ;
              let p = this.getViz3_1Data( data_init , false )

              //console.info("p",p) ; 
              this.dataviz_conf_viz3_1.dataset = p.dataset ;
                this.oGraphic_3_1 = new CanChart( this.dataviz_conf_viz3_1 ).render() ;
                this.oTrend3_1 = this.oGraphic_3_1.vizInstance ;
                // console.info("this.oTrend3_1",this.oTrend3_1) ; 
              });
              // this.loadViz3_1 

              console.info('A initFullMap') ; 

            }) ; 
          }, 2000 )
      });
    },

    openOverlay : function(d){
      this.current_country = d ; 
      //console.info("this.current_country.properties",this.current_country.properties) ; 
      this.country_model = this.current_country.properties.UN_CODE ; 
      $('.overlay').show(); 
      $('body').addClass('opened') ; 
      $('section.slide').css('opacity',0.1) ;   
      
      this.launchVizMap_c() ;  //this.current_country.properties.CNTRY_TERR) ; 
    },

    hideOverlay : function(){
      
      $('.overlay').hide(); 
      $('section.slide').css('opacity',1) ; 
      $('body').removeClass('opened') ;

    },

    changeCountry : function(){

      this.launchVizMap_c() ; // this.country_model )
    } , 

    launchVizMap_b : function(){

      // return ; 

      this.margin_trends_ = { top: 50 , right: 100, bottom: 50, left: 100 } ;

      // special mobile
      if ( md.mobile() != null) 
        this.margin_trends_ = { top: 50 , right: 50, bottom: 40, left: 70 } ;

      this.height_trends_ = ( md.mobile() != null) ? $(window).height()/1.5 : 700 - this.margin_trends_.top - this.margin_trends_.bottom ; 

      this.width_trends_  = $(window).width() - this.margin_trends_.left - this.margin_trends_.right ; 

      if ( this.height_trends_ > this.width_trends_ ) this.height_trends_ = this.width_trends_ ; 

      this.dataviz_conf_viz3_1 = {
          'type'      : 'trend' , 
          'title'     : false , 
          'width'     : ( md.mobile() != null) ? this.width_trends_ : this.width_trends_/2 , 
          'height'    : this.height_trends_ , 
          'margin'    : this.margin_trends_ , 
          'container' : '#viz3_1',
          'id'        : 'graphic_3_1' , 
          'dataset' : [] ,
          'chart' : {
              'transition_duration' : 750 , 
              'x' : { 'key' : 'year' , 'label' : 'Period' }, 
              'y' : { 'key' : 'value' , 'label' : 'Age-standardised rate (World) per 100,000'  }, 
              'freeze_legend' : true , 
              'square'    : false , 
              //'min_zero'  : true , 
              //'lock_y_max': false ,
              'x_min'     : 1900 , 
              'x_max'     : 2050 , 
              'y_min'     : 0 , 
              'min_zero' : true , 
              'force_y_min':0 , 
              'lock_y_max' :false,
              'lock_y_min' : true, 
              //'y_max'     : 100 , 
              'curve'     : 'curveBasis' , 
              'scale'     : 'linear' , 
              'nb_ticks_x' : ( md.mobile() != null) ? 6 : 10 , 
              'suffix_tooltip' : ''
          } , 
          'downloads' : false ,
          'copyright' : false 
      } ;

    }, 

    getViz3_1Data : function( data_ , init = true ){

      let all_values = [] , inc_data = [] , mort_data = [] ; 

      if ( init == true )
      {
        for ( var y = 1950 ; y <= 2020 ; y++ )
        {
          inc_data.push({ 'year' : y , 'value' : 0 }) ; 
          mort_data.push({ 'year' : y , 'value' : 0 }) ; 
        }
      }
      else
      {
        inc_data = data_.filter( f => parseFloat(f.type) == 0).map(m=>{
          let val = parseFloat(m.asr) ; 
          all_values.push(val) ;
          return { 'year' : parseFloat(m.year) , 'value' : val }
        })
        mort_data =  data_.filter( f => parseFloat(f.type) == 1).map(m=>{
          let val = parseFloat(m.asr) ; 
          all_values.push(val) ;
          return { 'year' : parseFloat(m.year) , 'value' : val }
        })
        /*
        inc_data = data_.filter( f => { return f.incid != 'NA' }).map(m=>{
          let val = parseFloat(m.incid) ; 
          all_values.push(val) ;
          return { 'year' : parseFloat(m.year) , 'value' : val }
        })

        mort_data =  data_.filter( f => { return f.mort != 'NA' }).map(m=>{
          let val = parseFloat(m.mort) ; 
          all_values.push(val) ;
          return { 'year' : parseFloat(m.year) , 'value' : val }
        })*/
      }

      let dataset = [] ; 

      if ( inc_data.length > 0 )
        dataset.push({ 
          id : 'inc', 
          label : 'Incidence' ,
          color : '#383f59' ,  
          stroke_width : '3px' , 
          values : inc_data });

      if ( mort_data.length > 0 )
        dataset.push({ 
          id : 'mort', 
          label : 'Mortality' ,
          color : '#d52e86' ,  
          stroke_width : '3px' , 
          values : mort_data 
        }); 

      return { dataset : dataset , all_values : all_values } ; 
    },
    /**
    * Promise loading viz 4
    * @param (array) data from .csv
    * @return (object)
    */
    launchVizMap_c : function(){  

      //this.name = name ;
      this.list_circles = sortByKey(this.list_circles,'SOVEREIGN','ASC') ; 

      this.name = this.list_circles.find( f => f.UN_CODE == this.country_model ).CNTRY_TERR ;   
      
      let data_ = this.data_.filter( f => { return f.country_code == this.country_model }) ;   

      let p = this.getViz3_1Data( data_ , false )

      // console.info("this.country_model",this.country_model,this.name,p);

      this.dataviz_conf_viz3_1.dataset = p.dataset ;
      this.dataviz_conf_viz3_1.chart.force_y_min = 0 ; //  
      this.dataviz_conf_viz3_1.chart.y_max = d3.max( p.all_values ) ; 

      // this.oTrend3_1.lockScale(true) ; 
      this.oTrend3_1.updateDataset( p.dataset );
      let axis_ = this.oTrend3_1.calculateMax() ;  

      axis_.x_min = 1970 ; 
      axis_.x_max = 2030 ; 
      axis_.y_min = 0 ; 

      this.oTrend3_1.updateDomains( axis_ ) ;  

      this.oTrend3_1.updateAllAxisLines() ; 
      this.oTrend3_1.updateLegendLines();     
      this.oTrend3_1.updateLines() ;

    },

    /**
    * Viz with ages groups
    * @param (string)
    * @return (no return)
    */
    launchTrendsVizCountries : function(){

      this.margin_trends  = { top: 50 , right: 150, bottom: 50 , left: 100 } ;
      this.height_trends  = $(window).height()/1.2 - this.margin_trends.top - this.margin_trends.bottom ; 
      this.width_trends   = $(window).width()/1.5 - this.margin_trends.left - this.margin_trends.right ; 

      if ( md.mobile() != null) 
      {
        this.margin_trends  = { top: 25 , right: 50, bottom: 50 , left: 50 } ;
        this.height_trends  = $(window).width() - this.margin_trends.top - this.margin_trends.bottom ; 
        this.width_trends   = $(window).width() - this.margin_trends.left - this.margin_trends.right ;
      }

      this.dataviz_conf_viz4 = {
        'type'      : 'trend' , 
        'title'     : false , 
        'width'     : this.width_trends , 
        'height'    : this.height_trends , 
        'margin'    : this.margin_trends , 
        'container' : '#viz4',
        'id'        : 'graphic4' , 
        'dataset' : [] ,
        'chart' : {
            'transition_duration' : 750 , 
            'x' : { 'key' : 'year' , 'label' : 'Period' }, 
            'y' : { 'key' : 'value' , 'label' : 'Age-standardised rate (World) per 100,000'  }, 
            'freeze_legend' : true , 
            'square'    : false , 
            'min_zero'  : true , 
            'lock_y_max': false ,
            'x_min'     : 1950 , 
            'x_max'     : 2010 , 
            'y_min'     : 0 , 
            'force_y_min':0 , 
            'y_max'     : 100 , 
            'curve'     : 'curveBasis' , 
            'scale'     : 'linear' , 
            'nb_ticks_x' : 5 , 
            'suffix_tooltip' : ''
        } , 
        'downloads' : false ,
        'copyright' : false 
      } ;

      fetch( process.env.VUE_APP_GRAPHICS_HOST_LOCAL + "/data/asr-by-ages.csv" ).then( this.loadViz4 )
      
    }, 

    /**
    * Capitalize first letter, equivalent of PHP ucfirst
    * @param (string)
    * @return (string)
    */
    capitalize : function( string ) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },

    /**
    * Promise loading viz 4
    * @param (array) data from .csv
    * @return (object)
    */
    loadViz4 : function( response ){  

      response.text().then( (data) => {         

        this.dataset_trends = d3.nest()
            .key( a => a.age ) 
            .key( c => c.country_lab ) 
            .entries( this.csvJSON(data) )
          ;

        this.legend_trends = this.dataset_trends.map( age => {
          return this.capitalize( age.key ) ;
        })  

        setTimeout(() => {
        
          this.current_countries = [] ; //["Norway"] ; 
          if ( md.mobile() != null ){
            this.current_countries = ["Norway","Denmark","Australia","New Zealand","Ireland","Canada","United Kingdom"] ; 
          }
          let p = this.getDataViz4( this.age_group , false , this.current_countries.filter( this.onlyUnique ) ) ; 

          //this.dataviz_conf_viz4.dataset = p.dataset ;
          this.dataviz_conf_viz4.chart.x_min = 0 ; //d3.min( p.all_values.x ) ;  
          this.dataviz_conf_viz4.chart.x_max = d3.max( p.all_values.x ) ;

          this.oGraphic = new CanChart( this.dataviz_conf_viz4 ).render() ;
          this.oTrend4 = this.oGraphic.vizInstance ; 

          if ( md.mobile() != null) 
          {
            this.updateViz4(this.age_group,this.current_countries) ; 

            let legend_mobile = [] ; 
            this.current_countries.forEach( (f)=>{ 
              legend_mobile.push({
                label : f , 
                color : this.colors[f]
              });
            });

            this.legend_trends_mobile = legend_mobile ;
          
          }

          // latest step loaded
          console.info('D loadViz4 End') ; 
          this.startStory() ; 
          
        }, 2000 ) ; 

        // hander scrolling events
        // this.scollListener();

      }) ;

    },

    /**
    * When latest csv is loaded, then allow to start story
    * @param (no param)
    **/
    startStory : function(){

      $('header,#story,footer').animate({opacity:1},250).removeClass('hidden_');
      $('body').addClass('opened') ; 
      $('#loading').fadeOut();

    } , 

    /**
    * Format dataviz for viz4
    * @param (string) age group
    * @param (bool) init or not
    @ @param (array) id of countries to add
    * @return (array)
    */
    getDataViz4 : function ( age , init , countries ){

      let all_values = { x : [] , y : [] } ; 
      
      // console.info("this.dataset_trends",this.dataset_trends) ; 

      this.dataset4 = this.dataset_trends.find( (d) =>{ return (this.capitalize(d.key) == age) }).values
        .filter( (f) => ( countries.includes( f.key )) )
        .map( row =>{
        return {
          id : row.key , 
          label : row.key , 
          color : this.colors[row.key] , 
          stroke_width : '3px' , 
          values : row.values.map( r => {

            all_values.x.push( int(r.year) ) ; 
            all_values.y.push( ( init == true ) ? 0 : parseFloat(r.asr) )

            return {
              year : int(r.year), 
              value : ( init == true ) ? 0 : parseFloat(r.asr)//,
              //stroke_width : '3px'
            }
          })
        }
      }) ; 

      return {
        dataset : this.dataset4 , 
        all_values : all_values
      } ; 
    } , 

    onlyUnique : function (value, index, self) { 
      return self.indexOf(value) === index;
    } , 

    /**
    * Update viz depending on age
    * @param (string) update dataset 
    */
    updateViz4 : function( age , countries ){

      // console.info("step A updateViz4") ; 

      this.age_group = age ; 

      let p = this.getDataViz4( age , false , countries.filter( this.onlyUnique ) ) ; 
      //console.info("step B updateViz4",p) ; 

      this.dataviz_conf_viz4.dataset = p.dataset ;
      this.dataviz_conf_viz4.chart.x_min = d3.min( p.all_values.x ) ;
      this.dataviz_conf_viz4.chart.force_y_min = 0 ; //  
      this.dataviz_conf_viz4.chart.x_max = d3.max( p.all_values.x ) ; 

      console.info("type of",typeof(this.oTrend4.updateDataset)) ; 
      if ( typeof( this.oTrend4.updateDataset) != 'function' ) return ; 

      this.oTrend4.updateDataset( p.dataset );
      this.axis = this.oTrend4.calculateMax() ;  

      this.oTrend4.updateDomains( this.axis ) ;  

      this.oTrend4.updateAllAxisLines() ; 
      this.oTrend4.updateLegendLines();     
      this.oTrend4.updateLines() ;

    }, 

    launchVizDoubleBars : function(){

        let conf = {
          width : this.width + 200 ,
          height : 500, // adjust for height of input bar div
          mode_default : 'bar',
          mode : 'bar' , 
          submode_default : 'all' , 
          submode : 'all', 
          groupby_default : "country",
          gender_default : "0",
          period_default : "1",
          age_group_default : "All",
          stage_default:"Distant",
          cancer_default: "Colon cancer",
          group_cbox_map : {
              'country': 'countries',
              'sub_region': 'registries',
          },
          stages : 
          { 
              'TNM' : {
                  'colors' : ['#E41E26','#3280B8','#49AE4B','#954F9E'] ,
                  'labels' : ['Stage I','Stage II','Stage III','Stage IV'] , 
                  'positions' : [ 0 , 1 , 2 , 3 ] , 
                  'scale' : undefined
              },
              'SEER' : {
                  'colors' : ['#F68021','#EE84B5','#293285'] ,
                  'labels' : ['Localised','Regional','Distant'], 
                  'positions' : [ 0 , 1 , 2 ] , 
                  'scale' : undefined
              }
          },
          countries : [],
          cancers:[],
          genders : [],
          registries : [],
          countryOptions : [],
          cancersiteOptions : [],
          stageOptions : [] , 
          stage_mode : "compare" ,  // all : list of all , compare : divide per 3 or 4 sub stages
          stageTypeOptions : [] , 
          yearOptions : [],
          genderOptions : [],
          provincesOption : [],
          nameKeys:["Incidence (ASR)", "Mortality (ASR)"],
          abbreviations:{},
          objData : [],
          jsonData : [],
          chartData : [],
          stackedData : [], 
          y2ChartData : [],
          // axis
          x0_domains : [] , 
          tooltip_data : [],
          lock_data : false,
          lock_survival : false , 
          lock_max : false,
          max_asr : 0,
          max_survival : 0,
          max_asr_overall : 0 , 
          max_survival_overall : 0 , 
          max_asr_get : undefined , 
          max_survival_get : undefined , 
          show_ci : '',
          data : [],
          chart : {} ,
          player : {} ,
          tooltip : d3.select("body").append("div")
            .attr("class", "canTooltip")
            .style("opacity", 0),
          color_map : {},
          ageGroupOptions : [
                { 'label' : "15–99", "key" : undefined ,  'value' : "15-99" },
                { 'label' : "15–44", "key" : "one" , 'value' : "15-44" }, 
                { 'label' : "45–54", "key" : "two" , 'value' : "45-54" }, 
                { 'label' : "55–64", "key" : "three" , 'value' : "55-64" }, 
                { 'label' : "65–74", "key" : "four" , 'value' : "65-74" }, 
                { 'label' : "75-99", "key" : "five" , 'value' : "75-99" }
            ]
        } ;

        // overide color_map
      conf.color_map.CANADA = "#1f9f65" ; 
      conf.color_map.AUSTRALIA = "#aa68ac" ; 
      conf.color_map['NEW ZEALAND'] = "#ed8db0" ; 
      conf.color_map.DENMARK = "#a7a8ac" ; 
      conf.color_map.UK = "#ee4724" ; 
      conf.color_map["UNITED KINGDOM"] = "#ee4724" ; 
      conf.color_map.NORWAY = "#089ad0" ; 
      conf.color_map.IRELAND = "#ec8a2b" ;

      // 50 for to margin and 30 for legend
      let margin = {top: 100, top_legend : 0 , right: 100, bottom: 50 , left: 150 }

      // adjust margin bottom
      if ( $(window).width() <= 1440 ) 
      {
        margin.top = 80 ; 
        margin.bottom = 30 ; 
      }

      let w_full = '100%' ; 
      let width = this.width_trends - margin.right ; // $(window).width()/1.7 - margin.left - margin.right ; // - 140;
      let height = $(window).height() - margin.top - margin.bottom  ; // this.height_trends ; // 700 - margin.top - margin.bottom

      if ( $(window).width() <= 1280 ) 
      {
        height = height-100 ; 
        conf.height = height- margin.top - margin.bottom - 50  ; 
      }
      // console.info("viz5 height" , height ) ; 

      if ( md.mobile() != null) 
      {
        w_full = $(window).width();
        margin = {top: 50, top_legend : 0 , right: 50, bottom: 50 , left: 80 }
        width = this.width_trends - margin.right ;
        height = ($(window).height()/2) - margin.top - margin.bottom  ;
        conf.height = height - 50 ;  
      }

      // append svg
      this.viz5 = d3.select("#viz5")
          .append("svg")
          .attr('width', w_full)
          .attr('height', height )
          .attr('id','stacked-viz')
          //.attr("viewBox", "0 0 1000 1200")
          .attr("preserveAspectRatio", "xMidYMid meet")

      //console.info( $(window).height() , 'vs' , height ) ; 
      //height = $(window).height() / 2 ; 

      //const graph1end = Math.floor(width * 2 / 3) - 10;
      const graph1end = Math.floor(width)  ; 
      const graph2start = graph1end + 20;
      
      const defs_ = this.viz5.append('defs')
      
      defs_
          .append('marker').attr('id','arrow_right').attr('orient','auto').attr('markerWidth',2).attr('markerHeight',4).attr('refX',0.1).attr('refY',2).attr('orient','auto-start-reverse')
          .append('path').attr('d','M0,0 V4 L2,2 Z').attr('fill','#000000') ; 

      defs_
          .append('marker').attr('id','arrow_left').attr('orient','auto').attr('markerWidth',2).attr('markerHeight',4).attr('refX',0.1).attr('refY',2)
          .append('path').attr('d','M0,0 V4 L2,2 Z').attr('fill','#000000') ; 


      const g = this.viz5.append('g')
          .attr('id', 'chart_content')
          .attr('transform', 'translate(' + margin.left + ',' + (margin.top )+ ')');
      const transition_duration = 750 ;

      var y0 = d3.scaleBand()
          //.range([0, graph1end])
          .rangeRound([conf.height,0])
          .paddingInner(0.05)

      var y1 = d3.scaleBand()
          .padding(0.1)
      var y2 = d3.scaleBand()
          .padding(0.1)

      let ageScale = this.ageGrpScale(conf.ageGroupOptions)  ; 

      var x   = d3.scaleLinear().rangeRound([0,width])
      
      var c1  = d3.scaleOrdinal().range(conf.stages.SEER.colors).domain(conf.stages.SEER.labels);
      var c2  = d3.scaleOrdinal().range(conf.stages.TNM.colors).domain(conf.stages.TNM.labels);

      conf.stages.SEER.scale = c1 ; 
      conf.stages.TNM.scale = c2 ; 

      // main color of population
      var z = d3.scaleOrdinal()
          .range([... new Set(Object.values(conf.color_map))])

      var z1 , z2 ;

      g.append('text').attr("class", "x legend_bottom")
          .attr("text-anchor", "middle")
          .attr("y", conf.height + margin.bottom + 8 )
          .attr("x",width/2)
          .text("% of all cases");
      
      // axis 
      let axisGroup ; 

      const xAxis = g.append('g')
          .attr('class', 'x axis')
          .attr('transform', `translate(0, ${conf.height})`)

      var yAxis ;
                     
      let grid_y = g.append("g") // draw grid y major
          .attr("class", "grid grid-y") ; 

      // let axisLeft = d3.axisLeft(y).ticks(10).tickSize(-width).tickFormat("") ; 
      d3.selectAll("g.grid.grid-y")
          //.call( d3.axisLeft(x).ticks(15).tickSize(-width).tickFormat("") )
      ;

      var all_percent = [] , all_x_percent = [] , sum_percent = 0 ; 

      const barContainer = g.append('g').attr('class','g_bar1');
      let lineContainer ; 

      let y0_domains = ["SEER"] ; 
          y0.domain( y0_domains ) ;

          // get max over all time
          x.domain([0,100]).nice(); 

          let data = [] , cpt = 1  ; 

          this.data.viz5.forEach( row =>{
            row.values.forEach( v =>{
              v.label = row.label ; 
              v.id = cpt ;
              data.push(v) ;
              cpt++ ; 
            })
          })

          let colorScale = d3.scaleOrdinal()
          .range(['#d52e86','#494BE1','#009EFE'])
          .domain(['Localised','Regional','Distant']) ; 

    let left_bars = (width/2)-170+margin.left ; 
          this.viz5.append("g")
        .attr("class", "legendOrdinal")
        .attr("transform", `translate(${left_bars},${( md.mobile() != null)?0:30})`);

    var legendOrdinal = d3.legendColor()
      .shapeWidth((md.mobile() != null)?80:100)
      .shapeHeight((md.mobile() != null)?10:30)
      .shapePadding((md.mobile() != null)?5:20)
      .labelOffset((md.mobile() != null)?'0px':'15px')
      .orient('horizontal')
      .scale(colorScale);

    this.viz5.select(".legendOrdinal")
        .call(legendOrdinal);

          let valueKeys= this.data.viz5
            .sort((a, b)=>{ return d3.ascending(a.label, b.label)})
            .map((item)=>{ return item.label });


        d3.selectAll('#viz5 .legendCells .swatch')
        .on("mousemove",(d)=>{
          d3.selectAll('#viz5 rect.poly')
            .style('opacity',(b)=>{
              return ((b.stage_type==d)?1:0.2);
            })
          ;
          d3.selectAll('#viz5 text.text')
            .style('opacity',(b)=>{
              return ((b.stage_type==d)?1:0.2);
            })
            .style('font-weight',(f)=>{
              return ((f.stage_type==d)?'bold':'light');
            });
          ;
        })
        .on("mouseout",(d)=>{
          d3.selectAll('#viz5 rect.poly').style('opacity',1); 
          d3.selectAll('#viz5 text.text').style('opacity',1).style('font-weight','light'); 
        });

        // filters by unique value
          valueKeys = valueKeys.filter((x, i, a) => a.indexOf(x) == i) ; 

          //y1.domain(y_values_keys).rangeRound([0,y0.bandwidth()])
          y2.domain(valueKeys).rangeRound([0,conf.height])

          d3.selectAll('.x.axis')
            .style('opacity',1)
            .transition()
            .duration(750)
            .call(d3.axisBottom(x).ticks(10).tickFormat(d=>{
                return d ; 
            }))

        let polygons = barContainer
              .selectAll('.poly')
              .data( data ,(d,i) => d.id )

          let texts = barContainer
              .selectAll('.text')
              .data( data ,(d,i) => 'txt_'+d.id )
          
          // console.info("bars step A",bars) ; 
          polygons
              .enter()
              .append( 'rect' )
              .attr('id',(d)=>d.id)
              .attr('class','poly')
              .attr('width',0)
              .attr('x', 0 )
              .attr('y', (d)=>{ 
                return y2(d.label) ; 
              })
              .attr('height',(d)=>{
                  return y2.bandwidth()
              })
          ;

          yAxis = g.append('g')
              .attr('class', 'y0 axis')
    
          axisGroup = d3
              .axisLeft(y0)
              .tickPadding(0)
              .tickSize(-this.width)
              .tickFormat("");

          /*g.selectAll('.y0.axis')
              .transition()
              .duration(750)
              //.attr('transform', `translate(0, ${height})`)
              .call(axisGroup)*/

          let g_x_axis = g.append('g').attr('class','group_y1') ;
        g_x_axis.append('g')
          .attr('class', 'y1 axis')
          //.attr('transform', `translate(0,${translate_y})`)
          .style('opacity',1)
          //.transition()
          //.duration(transition_duration)
          .call(d3.axisLeft(y2).tickSize(3).tickPadding(5).tickFormat(t=>t))

        texts
          .enter()
          .append( "text" )
          //.merge(bars)
          .attr('id',(d)=>'txt_'+d.id)
          .attr('class','text')
          .style('opacity',0)
          .attr('x', (d,i)=> { 

              let pos ; 
              all_percent.push(d.value) ; 

              pos = x( d3.sum(all_percent)-d.value) ;
              
              if ( Math.round(d3.sum(all_percent)) == 100 )
              {
                  all_percent = [] ; 
              }

              return pos+(x(d.value)/2) ; 
          })
          .attr('y', (d)=>{
            return y2(d.label)+(y2.bandwidth()/2) ;
          })
          .attr('text-anchor','middle')
          .attr('dominant-baseline','middle')
          // .text((d)=>d.value+'%')
      ;

      this.oViz5.x = x ; 
      this.oViz5.y2 = y2 ; 

      this.updateVizDoulbeBars();

      // update translate of legends
      let legends = ['translate(0,0)','translate(120,0)','translate(240,0)'] ; 

      $('#scrollama-graphic-section_4 svg .legendCells g.cell').each((cpt,cell)=>{
        $(cell).attr('transform',legends[cpt]) ; 
      })

      $('#scrollama-graphic-section_4 svg .legendCells g.cell text.label').each((cpt,text)=>{
        $(text).attr('transform','translate(50,48)') ; 
      })

    },  

    updateVizDoulbeBars : function(){

      var all_percent = [] , all_x_percent = [] , sum_percent = 0 ; 

      d3.selectAll('.poly')
            .transition()
            .duration(500)
            .attr('fill',(d)=>d.color)
            .attr('x', (d,i)=> { 
                
                let pos , value ; // = (d.stage_type=='SEER') ? c1(d.stage) : c2(d.stage);
                //idx_r = stages[d.stage_type].labels.indexOf(d.stage) ; 
                
                all_percent.push(d.value) ; 
                all_x_percent.push(this.oViz5.x(d.value)) ;

                // if first block, always start 0 
                if( i == 0 ) 
                {
                    sum_percent = 0 ; 
                    return 0 ; 
                }

                pos = d3.sum(all_x_percent)-this.oViz5.x(d.value) ;
                
                if ( Math.round(d3.sum(all_percent)) == 100 )
                {
                    all_percent = [] ; 
                    all_x_percent = [] ; 
                    //return 0 ; 
                }
                return pos ; 
            })
            .attr('y', (d)=>{ 
                return this.oViz5.y2(d.label);//+y0(d.stage_type) ;
            })
            .attr('width',(d)=>{
                let pos , sum ; 
                //idx_r = stages[d.stage_type].labels.indexOf(d.stage) ; 
                
                // 
                all_percent.push(d.value) ; 
                all_x_percent.push(this.oViz5.x(d.value)) ;

                sum = d3.sum(all_percent) ; 
                pos = d3.sum(all_percent)-d.value ; 

                if ( Math.round(d3.sum(all_percent)) == 100 )
                {
                    // if ( d3.sum(all_percent) != 100 )console.info(d.label,all_percent,d3.sum(all_percent)) ; 
                    
                    all_percent = [] ; 
                    all_x_percent = [] ; 

                }

                //if ( d.stage == 'Distant' || d.stage == 'Stage IV') return x(100) ; 

                return this.oViz5.x(d.value)
            })
            .attr('height',(d)=>{
                return this.oViz5.y2.bandwidth()
            })

        all_percent = [] ; 

        d3.selectAll('.text')
          .transition()
            .duration(500)
            .style('opacity',1)
            .text((d)=>d.value+'%')

        $('#viz5 .legendOrdinal').fadeIn();
        
    }, 

    ageGrpScale: function(ageGroupOptions){

      let legendData = ageGroupOptions.filter( a => a.value != 'All').map( a => a.key ) ; 
      let colors = ['#ffd8a6','#fc8210','#ff427f','#007892','#00005c'] ; 
      //colors = ['#ffd8a6','#fc8210','#ff427f','#007892'] ; 

      return  { 'domain' : legendData , 'range' : colors }     
    } , 

    launchMultiBars : function( id_viz , key_viz ){

      let conf = {
          width : this.width_trends ,
          height : $(window).height()/4, // 250, // adjust for height of input bar div
          margin : {top: 50 , right: 150, bottom: ($(window).width() <= 1280 ) ? 30 : 50 , left: 80 }
      };

      if ( md.mobile() != null)
        conf = {
          width : this.width_trends + 40 ,
          height : 150, // adjust for height of input bar div
          margin : {top: 50 , right: 20, bottom: 20 , left: 40 }
      }

      let x0_domains = d3.nest()
        .key(d=>d.label)
        .entries(this.data.viz6)
        .map(d=>d.key)
      ;

      let x1_domains = d3.nest()
        .key(d=>d.period)
        .entries(this.data.viz6)
        .map(d=>d.key)
      ;   

      let width_graph = conf.width - conf.margin.left ; 

      var x0 = d3.scaleBand()
            //.rangeRound([this.width - conf.margin.left - conf.margin.right,0])
            .rangeRound([width_graph,0])
            .paddingInner(0.06)

            x0.domain( x0_domains ) ;

          var x1 = d3.scaleBand()
            .padding((md.mobile()!=null)?0.1:0.4)

        x1.domain(x1_domains).rangeRound([0, x0.bandwidth()])

        var x2 = d3.scaleBand()
            .padding(0.5)

        var y = d3.scaleLinear().rangeRound([conf.height,0])
        y.domain([0,100]).nice()

        var y1 = d3.scaleLinear().rangeRound([conf.height,0]);

        // append svg
        this.viz6 = d3.select( id_viz )
            .append("svg")
            .attr("id","mutlti-bars-6")
            .attr('width', conf.width )
            .attr("height",conf.height + conf.margin.top + conf.margin.bottom )
            //.attr("viewBox", "0 0 1000 600")
            //.attr("preserveAspectRatio", "xMidYMid meet")

        this.viz6.append('text').attr("class", "y text_legend legend_left")
            .attr("text-anchor", "middle")
            .attr("transform", "rotate(-90)")
            .attr("y", (conf.margin.left/2)-((md.mobile()!=null)?8:0))
            .attr("x", -(conf.height/2)-conf.margin.top )
            .text("Five-year net survival");

        const g = this.viz6.append('g')
            .attr('id', 'chart_content')
            .attr('transform', 'translate(' + conf.margin.left + ','+ conf.margin.top +')');

        const xAxis = g.append('g')
            .attr('class', 'x axis')
            .attr('transform', `translate(0, ${conf.height})`)

        var yAxis = g.append('g')
            .attr('class', 'y axis') ;

        yAxis
              .transition()
              .duration(750)
                .call(d3.axisLeft(y).ticks(5).tickFormat(d=>{
                  return d;
                }))
                       
        let grid_y = g.append("g") // draw grid y major
            .attr("class", "grid grid-y") ; 

        d3.selectAll("g.grid.grid-y")
            .call( d3.axisLeft(y).ticks((md.mobile()!=null)?2:10).tickSize(-width_graph).tickFormat("") )
        ;

        let g_x_axis = g.append('g').attr('class','group_y1') ;
            g_x_axis.append('g')
              .attr('class', 'x0 axis')
              .attr('transform', `translate(0, ${conf.height})`)
              .style('opacity',1)
              .call(d3.axisBottom(x0).tickSizeOuter(0))

          let bars ; 

          let data = d3.nest()
            .key(d => d.cancer )
            .key( d => d.label )
            .entries( this.data.viz6 ) 

          let dataset = data[key_viz].values ; 

          const barContainer = g.append('g').attr('class','g_bar1');
            const barsWithData = barContainer
                .selectAll('g.bar1')
                .data( dataset , (d,i)=>{ return 'bar-'+d.key ; })

            let colors = [
              ['#DDD208','#FE9956','#F16BE8','#399FEF'], // ['#494BE1','#EA4B8E','#F56BE2','#399FEF'] , 
              ['#DDD208','#FE9956','#F16BE8','#399FEF'] , 
            ] ; 

            //var legend = d3.scaleLinear()
        //.domain([0,10])
        //.range(["rgb(46, 73, 123)", "rgb(71, 187, 94)"]);

            let colorScale = d3.scaleOrdinal()
            .range(colors[key_viz])
            .domain(x1_domains) ; 

          let trans_x = (md.mobile() != null) ? 80 : (conf.width/2)-162.5+conf.margin.left ; // 325 is the width of legend 
          this.viz6.append("g")
          .attr("class", "legendOrdinal")
          .attr("transform", `translate(${trans_x},0)`);

      var legendOrdinal = d3.legendColor()
        .shapeWidth((md.mobile()!= null)?55:70)
        .shapeHeight(( md.mobile() != null)?5:10)
        .labelOffset(5)
        .orient('horizontal')
        .scale(colorScale);

      this.viz6.select(".legendOrdinal")
          .call(legendOrdinal);


        d3.selectAll('.legendCells .cell')
          .on("mousemove",(d)=>{
            d3.selectAll('rect.bar')
              .style('opacity',(b)=>{
                return ((b.period==d)?1:0.2);
              })
              .style('stroke-dasharray',(b)=>{
                return ((b.period==d)?1:0);
              });
            d3.selectAll('text.txt_bar')
              .transition()
              .duration(250)
              .style('opacity',(b)=>{
                return ((b.period==d)?1:0);
              })
              .attr('y',(b)=>{
                return ((b.period==d)?y(b.value)-5:y(b.value)+20);
              })
          })
          .on("mouseout",(d)=>{
            d3.selectAll('rect.bar').style('opacity',1).style('stroke-dasharray',0) ; 
            d3.selectAll('text.txt_bar').style('opacity',0) ; 
          });

          bars = barsWithData
            .enter()
            .append('g')
            .attr('class','bar')
            .attr('id',(d,i)=>{ return 'bar-'+i ; })
            .attr('transform',  (d)=>{ return 'translate(' + x0(d.key) + ',0)' })
            .merge(barsWithData)
            .selectAll('rect')
            .data((d)=>{
              return Object.keys(d.values).map((k)=>{
                return {
                  key: k,
                  label : d.values[k].label, 
                  id:"bar-"+k+"-"+d.values[k].cancer+"-"+d.values[k].label,
                  period: d.values[k].period, 
                  value: d.values[k].value, 
                  color: colorScale(d.values[k].period)
                }
              })
            },(d)=>d.id)

          bars
            .enter()
                .append('text')
                .merge(bars)
              .attr('id',(d)=>`text_${d.id}`)
              .attr('class','txt_bar')
              //.attr('text-anchor','middle')
                .attr('x', (d)=>x1(d.period)-10)
                .attr('y',(d)=>y(d.value)+20)
                .style('opacity',0)
                .style('font-size','12px')
                .style('font-weight','500')
                .text((d)=>d.value.toFixed(1)+'%')

            bars
                .enter()
                .append('rect')
                .merge(bars)
              .attr('id',(d)=>d.id)
              .attr('class','bar')
              .attr('width', x1.bandwidth())
            .attr('fill', (d)=>d.color)
                .attr('x', (d)=>{ return x1(d.period) })
                .attr('y',(d)=>{ return y(0);})
            .attr('height',0) 
            //.style('stroke','#ffffff')
          ; 

          this.oViz6.conf = conf ; 
          this.oViz6.x1 = x1 ; 
          this.oViz6.y = y ; 

      // update translate of legends
      let legends = ['translate(0,0)','translate(85,0)','translate(170,0)','translate(255,0)'] ; 

      if ( md.mobile() == null )
      {
        $('#scrollama-graphic-section_5 svg .legendCells g.cell').each((cpt,cell)=>{
          $(cell).attr('transform',legends[cpt]) ; 
        })

        $('#scrollama-graphic-section_5 svg .legendCells g.cell text.label').each((cpt,text)=>{
          $(text).attr('transform','translate(35,28)') ; 
        })
      }

      if ( md.mobile() != null )
      {
        this.updateVizMultiBars('#viz6-2',1) ;  
        d3.selectAll('#viz6-1 svg rect.bar').style("opacity",1) ;
      }

    }, 
    
    updateVizMultiBars : function( id_viz , key_viz ){

      d3.selectAll(id_viz + ' rect.bar')
        .transition()
        .duration(500)
        .attr('y',(d)=>{ return this.oViz6.y(d.value);})
        .attr('height', (d)=>{ 
          return this.oViz6.conf.height - this.oViz6.y(d.value);
        })

      $(id_viz + ' .legendOrdinal').fadeIn();

    } , 

    launchViz7 : function( key_viz = 0 ){

      this.margin_trends  = { top: 50 , right: 150, bottom: 50, left: 100 } ;
      
      this.height_trends  = this.height_trends - this.margin_trends.top - this.margin_trends.bottom ; 
      this.width_trends   = this.width_trends - this.margin_trends.left - this.margin_trends.right ; 

      if ( md.mobile() != null )
      {
        this.margin_trends  = { top: 0 , right: 80, bottom: 100, left: 60 } ;
        this.width_trends   = $(window).width() - this.margin_trends.left - this.margin_trends.right ; 
      }

      this.dataviz_conf_viz7 = {
        'type'      : 'trend' , 
        'title'     : false , 
        'width'     : this.width_trends , 
        'height'    : this.height_trends , 
        'margin'    : this.margin_trends , 
        'container' : '#viz7',
        'id'        : 'graphic7' , 
        'dataset' : [] ,
        'chart' : {
          'transition_duration' : 750 , 
          'x' : { 'key' : 'year' , 'label' : 'Number of colon cancer deaths (in thousands)' }, 
          'y' : { 'key' : 'value' , 'label' : 'Age-standardised rate (World) per 100,000'  }, 
          'freeze_legend' : true , 
          'square'    : false , 
          'min_zero'  : true , 
          'lock_y_max': false ,
          'x_min'     : 1989 , 
          'x_max'     : 2035 , 
          'y_min'     : 0 , 
          'force_y_min':0 , 
          'y_max'     : 100 , 
          'curve'     : 'curveBasis' , 
          'scale'     : 'linear' , 
          'nb_ticks_x' : ( md.mobile() != null ) ? 6 : 10 , 
          'suffix_tooltip' : ''
        } , 
        'downloads' : false ,
        'copyright' : false 
      } ;

      let dataset = d3.nest()
        .key(d=>d.metric)
        .entries(this.data.viz7.colon)

      let dataset_1 = d3.nest()
        .key(d=>d.metric)
        .entries(this.data.viz7.rectum)

      this.final = dataset.concat(dataset_1) ; 
      this.colors_7 = ['#d52e86','#06d6a0'] ; 

      this.final
        //.filter( f => f.year < 2010 ) 
        .forEach( (d,i) => {
          d.id = i+'-'+d.key ; 
          d.label = d.key ;
          d.color = this.colors_7[key_viz] ; 
          // d.dash = true ; 
          d.stroke_width = (md.mobile()!=null)?2:5 ; 
          d.values.forEach((item) => {
            let val_ ; 
            if ( item.metric == 'cases' )
            {
              if ( item.value != undefined)
                val_ = parseFloat(item.value)/1000 ; 
              else
                val_ = parseFloat(item.cases)/1000 ; 
            }
            else
            {
              if ( item.value != undefined){
                val_ = item.value.replace(',','.') ; 
              }
              else{
                val_ = item.cases.replace(',','.') ;
              }
            }
            item.value =  val_ ; //? parseFloat(item.value)/1000 : item.value.replace(',','.') ; 
          })
      }) ; 

      let prediction = clone_var(dataset[1]) ; 
      dataset[1].values = dataset[1].values.filter( f =>{ return f.year < 2013 }) ; 
      prediction.dash = true ; 
      
      let prediction_1 = clone_var(this.final[3]) ; 
      this.final[3].values = this.final[3].values.filter( f =>{ return f.year < 2013 }) ; 
      prediction_1.dash = true ; 

      let final = [ dataset[1] , prediction , this.final[3] , prediction_1  ] ; 

      //this.final = final ; 
      // console.info("final => ", final ) ;
      
      this.dataviz_conf_viz7.dataset = final ;
      this.dataviz_conf_viz7.chart.y_min = 0 ; //d3.min( p.all_values.x ) ;  
      this.dataviz_conf_viz7.chart.y_max = 10 ; //300000  ;

      this.oGraphic_viz_7 = new CanChart( this.dataviz_conf_viz7 ).render() ;
      this.oTrend7 = this.oGraphic_viz_7.vizInstance ; 

      let all_values_left = this.data.viz7.colon.filter( d => d.metric == 'asr' ).map( m => m.value ) ; 
      let all_values_right = this.data.viz7.colon.filter( d => d.metric == 'cases' ).map( m => m.value ) ; 

      var y1 = d3.scaleLinear().range([this.height_trends,0])
      y1.domain([0,d3.max(all_values_right)]) ; 

      this.y1_7 = y1 ;

      let svg_graph = d3.select('#viz7 svg .line_graph') ;

      const yAxis2 = svg_graph.append('g')
        .attr('class', 'y2 axis')

      yAxis2
        .attr('transform', `translate(${this.width_trends+this.margin_trends.left},${this.margin_trends.top})`)
        .transition()
        .duration(750)
        .call(d3.axisRight(y1))

      var y_translate =  (this.height_trends/2)+int(this.margin_trends.top);

      let margin_y_title = (this.width_trends+this.margin_trends.right+15) ; 
      
      if ( md.mobile() != null ) margin_y_title = (this.width_trends+this.margin_trends.right+25) ; 

      let text_right = svg_graph.append("text") // add y axis subtitle
        .attr("id","y_title_right")
        .attr("class", "y_title")
        .attr("text-anchor", "middle")
        .attr("transform", "translate("+margin_y_title+"," +y_translate+ ") rotate(-90)")
        //.style('fill',this.colors_7[1])

      text_right
        .append('tspan')
        .text( "Number of cancer deaths (in thousands)"); //" ) ; 

      svg_graph.append('line')
        .attr('id','line_left_viz7')
        .attr('x1',margin_y_title + 10)
        .attr('y1',int(this.margin_trends.top) + 150 )
        .attr('x2',margin_y_title + 10)
        .attr('y2',this.height_trends - 120 )
        .attr('stroke',this.colors_7[1])
        .attr('fill',this.colors_7[1])
        .attr('stroke-width','3px')

      svg_graph.append('line')
        .attr('id','line_right_viz7')
        .attr('x1',45)
        .attr('y1',int(this.margin_trends.top) + 150 )
        .attr('x2',45)
        .attr('y2',this.height_trends - 120 )
        .attr('stroke',this.colors_7[0])
        .attr('fill',this.colors_7[0])
        .attr('stroke-width','3px')


      d3.selectAll('svg#graphic7 text.y_title_left')
        //.style('fill',this.colors_7[0])

      let transformX = ( ( this.oTrend7.width / 2 ) - (this.oTrend7.height / 2) + this.oTrend7.margin.left ) ;

      let group_lines_asr = svg_graph.append('g')
          .attr('class','group_lines_asr')
          .attr("transform", "translate("+this.margin_trends.left+","+this.margin_trends.top+")") 

      this.group_lines_asr = group_lines_asr  ; 

      this.oTrend7.updateDataset( final );
      this.axis = this.oTrend7.calculateMax() ;  

      this.oTrend7.updateDomains( this.axis ) ;  
      // this.oTrend7.updateAllAxisLines() ; 
      // this.oTrend7.updateLegendLines();     

      let d_annotation_num = this.final[1].values ; 

      // annotation numbers
      const labels = [
        {
          data: {date: this.final[1].values[8].year,close: this.final[3].values[9].value},
          dy: 58,
          dx: 0,
          note: { align: "middle"},
          id: "minimize-badge",
          connector: { end: "arrow" },
          subject: { radius: 5, radiusPadding: 10 }
        },
        {
          data: {date: this.final[3].values[5].year, close: this.final[1].values[6].value},
          dy: 100,
          dx: 0,
          note: { align: "middle"},
          id: "minimize-badge",
          connector: { end: "arrow" },
          subject: { radius: 5, radiusPadding: 10 }
        }
      ].map((l,i) => {
        l.note = Object.assign({}, l.note, { title: (i==1)?`Colon cancer`:`Rectal cancer`,
          label: ""})
        return l
      })

      let makeAnnotations = d3.annotation()
        .annotations(labels)
        .type(d3.annotationCalloutCircle)
        .accessors({ x: d => this.oTrend7.x_scale(d.date), 
          y: d => this.oTrend7.y_scale(d.close)
        })
        .accessorsInverse({
          date: d => this.oTrend7.x_scale.invert(d.x),
          close: d => this.oTrend7.y_scale.invert(d.y) 
        })

      svg_graph.append("g")
          .attr("class", "annotations_colon")
          .attr("transform", "translate("+this.margin_trends.left+","+this.margin_trends.top+")") 
          .call(makeAnnotations)

      // annotation asr
      const labels_asr = [
        {
          data: {date: this.final[0].values[5].year,close: this.final[0].values[17].value},
          dy: -100,
          dx: 0,
          note: { align: "middle"},
          id: "minimize-badge",
          connector: { end: "arrow" },
          subject: { radius: 5, radiusPadding: 10 }
        },
        {
          data: {date: this.final[2].values[8].year, close: this.final[2].values[17].value},
          dy: -68,
          dx: 0,
          note: { align: "middle"},
          id: "minimize-badge",
          connector: { end: "arrow" },
          subject: { radius: 5, radiusPadding: 10 }
        }
      ].map((l,i) => {
        l.note = Object.assign({}, l.note, { title: (i==0)?`Colon cancer`:`Rectal cancer`,
          label: ""})
        return l
      })

      let makeAnnotations_asr = d3.annotation()
        .annotations(labels_asr)
        .type(d3.annotationCalloutCircle)
        .accessors({ x: d => this.oTrend7.x_scale(d.date), 
          y: d => y1(d.close)
        })
        .accessorsInverse({
          date: d => this.oTrend7.x_scale.invert(d.x),
          close: d => y1.invert(d.y) 
        })
      svg_graph.append("g")
          .attr("class", "annotations_rectum")
          .attr("transform", "translate("+this.margin_trends.left+","+this.margin_trends.top+")") 
          .call(makeAnnotations_asr)

      if ( md.mobile() != null ) 
      {
        this.updateViz7Lines1() ; 
        
        //d3.selectAll('g.annotations_colon')
          //.style('transform','translate(100px,-5px)') ; 

      }
    }, 

    /**
    * Update viz depending on age
    * @param (string) update dataset 
    */
    updateViz7Lines1 : function(){

      let key_ = 0 ; 
      // add
      let prediction_asr = clone_var(this.final[key_]) ; 
      this.final[key_].values = this.final[key_].values.filter( f =>{ return f.year < 2013 }) ; 
      prediction_asr.dash = true ; 
      prediction_asr.values.map( m => m.dash = true ) ; 

      let prediction_rectum = clone_var(this.final[2]) ; 
      this.final[2].values = this.final[2].values.filter( f =>{ return f.year < 2013 }) ; 
      prediction_rectum.dash = true ; 
      prediction_rectum.values.map( m => m.dash = true ) ; 

      let final_asr = [ this.final[key_] , prediction_asr , this.final[2] , prediction_rectum ] ; 

      final_asr.forEach((item) => {
        item.color = this.colors_7[1] ; 
      })

      this.final_asr = final_asr ; 
      this.dataviz_conf_viz7.dataset = final_asr ;
      this.oTrend7.updateDataset( final_asr );
      this.axis = this.oTrend7.calculateMax() ;  

      this.oTrend7.updateDomains( this.axis ) ;  
      // this.oTrend7.updateAllAxisLines() ; 
      // this.oTrend7.updateLegendLines();

      
      //this.oTrend7.updateLines() ;
      let lines_asr = this.group_lines_asr.selectAll('.path_lines_asr')
          .data( final_asr , (d) => d.id  );

        let line_d3 = d3.line()
          .x((d)=>{ return this.oTrend7.x_scale( d.year ); })
          .y((d)=>{ return this.y1_7( d.value ); })
          .curve( d3[this.oTrend7.curve] ) ;

        let lines_tran = lines_asr
          .enter()
          .append("path")
          .attr('class','path_lines_asr')
          .attr('id',(d)=> d.id )
          .attr("clip-path", "url(#clip)")
          .attr("d", (d) => { return line_d3(d.values) ; })
          .attr("stroke", (d, i)=> d.color )
          .style("stroke-width", (d, i)=> d.stroke_width )
          .attr('stroke-dasharray',(d)=>{ 
              return (d.dash == true) ? 5 : 0 ; 
          })
          .attr("fill", "none") 
      ;

    
      
    } , 

    /**
    * Update viz depending on age
    * @param (string) update dataset 
    */
    updateViz7Lines2 : function(){

      // if ( this.y1_7 == undefined) return ; 
      let key_ = 0 ; 

      let prediction_num = clone_var(this.final[key_]) ; 
      this.final[key_].values = this.final[key_].values.filter( f =>{ return f.year < 2013 }) ; 
      prediction_num.dash = true ; 
      prediction_num.values.map( m => m.dash = true ) ; 
      let final_num = [ this.final[key_] , prediction_num ] ; 

      this.dataviz_conf_viz7.dataset = final_num ;
      this.oTrend7.updateDataset( final_num );
      this.oTrend7.updateLines() ;

    }, 

    playAnnotation : function( direction ){

      d3.selectAll('.annotation')
        .style('display',(a,i)=>{
          return (i<=this.annotation_cpt)?'block':'none';
        })

      if ( this.annotation_cpt < 6 ) this.annotation_cpt++ ; 

    }
  }
}

</script>

<style src="vue-scrollama/dist/vue-scrollama.css"></style>

<style lang="scss">

$font_size : 1.4em ; 
$dark_color: #151A2F;
$light_color: #fff ;
$bg: transparent /*GoldenRod*/;

.white{
  a{
    color: $dark_color ; 
  }
}

.dark{
  a{
    color: #fff ; 
  } 
  .story_marker{
    color: $dark_color ; 
  }
}

ul.pager{
  position: fixed ; 
  display: none ; 
  top: 50% ; 
  left: 20px ; 
  width: 30px ; 
  margin-top:-90px;
  z-index: 2 ; 
  li{
    margin-bottom: 15px ; 
    list-style-type: none ; 
    a{
      width: 15px ; 
      height: 15px ; 
      display: block ; 
      background: transparent;
      border-radius: 10px ; 
      border:solid 2px #fff ; 
      text-decoration: none;
      &.selected{
        background: #fff ;
      }
    }
  }
}



h1#main_title{

}

h2{
  font-size: 1.6em!important;
  font-weight: 900;
  padding-top: 50px;
  color: #fff ; 
}

h3{
  font-size: 1.4em!important; 
  font-weight: 800;
}

h4{
  font-size: 1.2em!important; 
  font-weight: 700;
}

header {
  height: 100vh;
  background: $bg ; 
}

#story{

  .intro,
  .outro {
    padding: 20vh;
  }

  div.overlay{
    background: rgba(255,255,255,0.95);
    padding: 20px ;
    width: 100%; 
    height: 100vh; 
    position: fixed;
    overflow: hidden; 
    display: none ; 
    z-index: 9 ; 
    a.close{
      display: block ;
      position: absolute;
      top: 40px; 
      right: 40px; 
      i{
        color: #151A2F;
      }
    }
    h2{
      color: #151A2F!important;
    }
    #viz3_1{
      width: 100% ; 
      height: 800px ; 

      select{
        display: block;
          width: 300px;
          margin: auto;
          margin-top: 100px;
      }
      svg{
        display: block ; 
        margin: auto ; 
        g.axis{
          path{
            stroke:#151A2F;
          }
          line{
            stroke:#151A2F;
            fill:#151A2F;
          }
        }
        g.grid.grid-x{
          display: none ; 
        }
        g.grid.grid-y{
          path.domain{
            display: none ; 
          }
          line{
            stroke: #ffffff ; 
            opacity: 0.2 ; 
          }
        }
      }
    }
  }

  .scrollama-steps{
    /*z-index: -1 ;*/ 
  }

  .graphic {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100% ; 
    &.graphic_third{
      width:100%;
    }
    &.graphic_right {
      margin-left: auto;
    }
    h2,h3{
      width: 100%;
      display: block;
      position: absolute;
      top: 0;
      height: 60px;
      padding: 30px 0 30px 0;
      text-align: center;
      margin: 0;
      color: #fff;
      background: #383f59 ; 
    }
    h2{
      text-transform: uppercase;
      font-weight: 900;
      top: 5px;
      background: #383f59 ; 
    }
    h3{
      top: 60px;
      padding: 15px 0 15px 0;
      background: #383f59 ; 
    }
    p.desc{
      display: block; 
      position: absolute ; 
      top: 150px ;
      color:#fff ; 
    }
    .viz{
      width: 100%;
      height: 85vh;
      margin-top: auto;
    }
    .source{
      left: 20px;
      font-size: 0.8em;
      display: flex ; 
      margin-top: auto;
      padding: 0 50px;
      position: absolute;
      bottom: 10px;
    }
  }

  ul.country{
    display: block;
    float: right;
    li{
      list-style-type:none; 
    }
  }
  
  .step {
    padding: 35vh 0;
    width: 5%;
    background-color: beige;
    border: 1px solid #ccc;
    display: flex;
    /*margin: 0 auto 30vh;*/
    margin: 0;
    margin-left: auto;
    margin-bottom: 0vh;
    height: 100vh;
    align-items: center;
    justify-content: center;
    color: #000 ; 
    &.step_third{
      margin: 0;
      margin-left: auto;
      margin-bottom: 25vh;
    }
    &.step_left{
      /*margin-left: 0;*/
    }
    &.step_hidden{
      opacity: 0;
    }
    &.step_show{
      opacity: 1;
    }
  }

  .overlay{
    svg{
      text{
        fill: #151A2F;
        font-family: "Frutiger-LT-Com-55-Roman" !important;
      }
    }
  }

  .scrollama-container{
    width: 100%;
  }

  /* common css grids */
  svg{
    display: block ; 
    margin: auto ; 
    text{
      fill: #fff;
    }
    g.grid.grid-x{
      display: none ; 
    }
    g.grid.grid-y{
      path.domain{
        display: none ; 
      }
      line{
        stroke: #ccc ; 
        opacity: 0.2 ; 
      }
    }
  }


  #scrollama-container-section_1{
    .graphic{
      /*background: SlateGray ;*/
      #viz1{
        height: 75vh ; 
        .sunburst{
          /*height: 600px;*/
          position: relative ; 
          .sunburst_legend{
            position: absolute;
            right: 0 ; 
            top: 0 ; 
            opacity: 0 ; 
            display: none;
          }
          &.window_1280{
            margin-top: 50px;
          }
          &#container_sunburst1{
            #sunburst_legend_3{
              top: 30px;
              /*right: 250px;*/
            }
            #sunburst_legend_4{
              top: 100px;
              /*right: 150px;*/
            }
            #sunburst_legend_5{
              top: 180px;
              /*right: 120px;*/
            }
            #sunburst_legend_6{
              top: 255px;
              /*right: 40px;*/
            }
            #sunburst_legend_7{
              top: 320px;
              /*right: 55px;*/
            }
          }
          &#container_sunburst2{
            #sunburst_legend_8{
              top: 30px;
              /*right: 250px;*/
            }
            #sunburst_legend_9{
              top: 100px;
              /*right: 150px;*/
            }
            #sunburst_legend_10{
              top: 240px;
              /*right: 100px;*/
            }
            #sunburst_legend_11{
              top: 355px;
              /*right: 40px;*/
            }
            #sunburst_legend_12{
              top: 460px;
              /*right: 90px;*/
            }
          }
          h4{
            position: absolute;
            top: 45% ;
            width: 100%;
            padding: 0 37%;
            opacity: 1 ; 
            z-index: -2; 
          }
          svg{
            margin:auto; 
            display: block;
            g.hidden_slice{
              opacity: 0   ; 
            }
          }
        }
      }
      .source_mobile{
        display: none;
      }
    }
    .scrollama-steps{
      z-index: -1!important;
    }
  }

  #scrollama-container-section_2{
    .graphic{
    /*background: DarkSlateGrey ;
      height: 150vh!important;*/
      p.desc{
        top: 115px!important;  
      }
      #viz3{
        position: absolute;
        top: 0;
        svg{
          margin-top: 120px ; 
          path.country{
          }
          circle.country{
            cursor: pointer; 
          }
          g.map_poly{
          }
          path.line.lines-4.dashed{
            display: none;
          }
          path.poly.abyei,path#path_ESH,path.jammu-and-kashmir{
            fill: #ccc!important;
          }
          g.map_lines{
            path.line{
              stroke: #fff!important;
            }
          }
        }
      }
      p.disclaimer{
        position: absolute;
        font-size: 0.8em;
        padding: 0 70px;
        bottom: 20px;
        line-height: 1.2em;
      }
    }
    .scrollama-steps{
      display: block;
      z-index: -1;
    }
  }

  #scrollama-container-section_3{
    h3{
      top: 0px!important;
      padding: 50px!important;
    }
    .graphic{
      /*background: Indigo ;*/
      #viz4{
        display: flex;
        margin-right: auto;
        margin-left: 15px;
        width: 70% ; 
        text.text_legend{
          font-size: .8em;
        }
        line.text_lines{
          display: none;
        }
      }
      .legend_mobile{
        display: none;
      }
      .legend{
        display: inline-block;
        float: left; 
        width: 100%;
        margin-bottom: auto;
        margin-top: 135px;
        padding-left: 0px;
        z-index: 8;
        li{
          list-style-type: none ; 
          display: flex;
          width: 100%;
          padding: 0 30px ;
          cursor: pointer ; 
          transition: all 0.2s ease-in-out;
          margin: 0 0 20px 0 ;
          padding-left: 0;
          input{
            display: none ; 
          }
          a{
            font-size: 1em;
            background: transparent;
            color: #fff;
            padding: 2px 5px;
            text-align: center;
            cursor: pointer;
            display: inline-block;
            width: 90px;
            border: solid 1px #fff; 
              label{
                display: block; 
                margin: 0 ;
                cursor: pointer; 
              }
              &:hover,&.selected{
              background: #fff ;
              color: #151A2F ; 
              font-weight: 800;
            }
          }
        }
      }
      ul.country{
        display: flex;
        width: 15% ; 
      }
      .axis-x{
        text{
          font-size: 1em;
        } 
      }

      path.mouse-line{
        stroke: #fff ;
        fill: #fff ; 
      }
      text.mouse-txt{
        fill: #fff ; 
      } 

      
    }
    .scrollama-steps{
      z-index: -1!important;
    }
    .step{
      background: none;
      border: none ;
      width: 25%;
      padding: 20px;
      margin-bottom: 10vh;
      height: auto!important;
      &:last-child{
        margin-bottom: 50vh;
      }
      .story{
        font-weight: 500; 
        margin-right: 40px;
        padding-left: 20px;
        h4{
          display: inline-block;
          text-align: left;
          padding-left: 0;
          width: auto;
          padding: 3px 15px 3px 0 ;
          color: #fff ; 
          font-weight: 800;
          border-bottom: solid 3px #fff;
          &.title_norway{
            border-color:#E8A49C;
          }
          &.title_new_zealand{
            border-color:#3C4CAD;
          }
          &.title_australia{
            border-color:#F9C449;
          }
          &.title_denmark{
            border-color:#F04393;
          }
          &.title_ireland{
            border-color:#7ec46c;
          }
          &.title_uk{
            border-color:#5f4db3;
          }
          &.title_canada{
            border-color:#d6d6d6;
          }
        }
      }
    }
  }

  #scrollama-container-section_4{
    .graphic{
      /*background: Crimson ;*/
      #viz5{
        width: 60%;
        display: flex;
        margin-right: auto;
        margin-top: 80px;
        min-height: auto ;
        .legendOrdinal{
          display: none ; 
          /*transform: translate(470px, 30px)!important;*/
          .legendCells{
            g{
              /*cursor: pointer ;*/ 
            }
          }
          text{
            font-size: 1em;
            font-weight: 400; 
          }
        }
        g.g_bar1{
          font-weight: lighter;
        }
        g.grid-y{
          display: none;
        }
      }
      #viz5_desc{
        display: block;
        width: 40%;
        padding: 40px ; 
        margin-top: 100px;
        #marker-text-5-1,#marker-text-5-2{
          height: 100vh ;
          /*border: solid 1px red ;*/
        }

        .desc{
          display: inline-block;
          float: left; 
          width: 100%;
          padding: 50px 0 ; 
          font-size: 1.2em;
          transition: all 0.2s ease-in-out;
          span{
            display: inline-block;
          }
        }

        #text-5-1{
          width: 400px;
          display: none ; 
          transition: all 0.2s ease-in-out;
          span.selected{
            background: #d52e86 ; 
            display: inline-block;
            text-shadow: 1px 1px rgba(0,0,0,0.7) ; 
            height: 24px;
          }
        }

        #text-5-2{
          width: 400px;
          display: none ; 
          transition: all 0.2s ease-in-out;
          span.selected{
            background: #009efe;
            display: inline-block;
            text-shadow: 1px 1px rgba(0,0,0,0.7) ; 
            height: 24px;
          }
        }
      }
    }
    .scrollama-steps{
      z-index: -1;
      /*opacity: 0;*/
      .step{
        height: 25vh!important;
        &:nth-child(2){
          height: 100vh!important;
        }
      }
    }
  }

  #scrollama-container-section_5{
    .graphic{
      /*background: Teal ;*/
      #viz6{
        width: 70%;
        display: block;
        margin-right: auto;
        /*min-height: 600px;*/
        margin-top: 75px;
        h3{
          text-align:left ; 
          position: absolute;
        }

        .viz6{
          display: inline-block;
          min-height: 300px; 
          width: 100%;
          position: relative ; 
          h4{

            position: absolute;
            text-align: left;
          }
        }
        .grid-y{
          display: block!important;
          path{
            display: none;
          }
        }

        .grid-y .tick line {
            stroke-width: 0.6px;
            stroke: #ccc;
            stroke-dasharray:1;
        }

        .legendOrdinal{
          display: none ; 

          .legendCells{
            g{
              /*cursor: pointer ;*/
            }
          }
          text{
            font-size: 0.9em;
          }
        }
      }
      #viz6-2{
        opacity: 0 ; 
        h4{
          opacity: 0;
        }
        .legendOrdinal{
          display: none!important; 
        }
      }
      #viz6_desc{
        width: 30%;
        display: block; 
        padding-top: 150px;
        .desc{
          display: inline-block;
          float: left; 
          width: 100%;
          padding: 20px 0 ; 
          font-size: 1.2em;
          transition: all 0.2s ease-in-out;
        }
        #text-6-1,#text-6-2,#text-6-3{
          display: none ; 
          width: 400px ; 
          top: 150px;
        }

        #text-6-1{
          span.selected{
            background: #ddd208 ;
            display: inline-block;
            text-shadow: 1px 1px rgba(0,0,0,0.7) ; 
            height: 22px;
            &.selected_yellow{
              color: #383f59 ; 
              text-shadow: none;
            }
          }
          span.selected2{
            background: #399fef ;
            display: inline-block;
            text-shadow: 1px 1px rgba(0,0,0,0.7) ; 
            height: 22px;
          }
        }

        #text-6-2{
          span.selected{
            background: #399fef ;
            display: inline-block;
            text-shadow: 1px 1px rgba(0,0,0,0.7) ; 
            height: 22px;
          }
        }

        #text-6-3{
          top: 550px ; 
        }
      }
    }
    .scrollama-steps{
      z-index: -1;
      /*opacity: 0;*/
    }
  }

  #scrollama-container-section_6{
    .graphic{
      /*background: YellowGreen ;*/
      #viz7{
        width: 60%;
        display: flex;
        margin-right: auto;
        min-height: 600px;
        .group_lines{
          display: none; 
        }
        g.annotations_rectum,g.annotations_colon{
          display: none;
        }
        path.subject{
          display: none;
        }
        text.annotation-note-title{
          font-size: 0.8em;
          font-style: italic;
          font-weight: 500;
        }

        /*g.annotations_rectum{
          g.annotation:nth-child(2){
            text.annotation-note-title tspan{
              opacity: 0
            }
          }
        }

        g.annotations_colon{
          g.annotation:nth-child(2){
            text.annotation-note-title tspan{
              opacity: 0
            }
          }
        }*/

      }
      #viz7_desc{
        display: block;
        width: 40%;
        padding: 40px ; 
        margin-top: 150px;
        .desc{
          display: inline-block;
          float: left; 
          width: 100%;
          padding: 50px 0 ; 
          font-size: 1.2em;
          transition: all 0.2s ease-in-out;
          span.subtext{
            display: none; 
            .d_rates{
              display: inline-block;
              background: #d52e86 ;
              height: 22px;
            }
            .d_num{
              display: inline-block;
              background: #06d6a0 ;
              color: #383f59 ;
              height: 22px;
            }
          }
        }
      }
      
      g.legend_lines{
        display:none;
      }
    }
    .scrollama-steps{
      z-index: -1;
      /*opacity: 0;*/
    }
  }
  /*.graphic{
    background: transparent !important;
  }*/
}


.canTooltip,.canToolTip{
    background: #ffffff;
    border: solid 1px #eee;
    box-shadow: 0 4px 8px rgba(0,0,0,.2);
    color: #333;
    display: none;
    left: 130px;
    padding: 10px ;
    position: absolute;
    text-align: center;
    top: 95px;
    z-index: 10;
    h5{
        margin: 0 ; 
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 4px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100% ; 
        text-align: left ;
        color: #000 !important;
    }
    table{
        border:none ; 
        width: 100% ; 
        font-size: 12px ; 
        color: #000 !important;
        tr{
            border-bottom: dotted 1px #cccccc ; 
            padding: 3px 0 ; 
            td.metric{
                text-align: left; 
                padding-right: 10px ; 
                
            }

            span.separator{
              display: inline-block; 
              width: 4px;
              height: 10px ;
              margin-right:3px;
            }

            span.left-border{
              display: inline-sblock;
              margin-right: 5px;
              height: 9px;
              border-left: solid 10px blue;
            }

            td.value{
                font-weight: bold ; 
                text-align: right ; 
                vertical-align: top;
            }
        }
    }
    .g-tip-caret {
        position: absolute;
        bottom: -5.5px;
        fill: #fff;
        stroke: none;
    }      

    &.arrow_down:after{
        content: " ";
        position: absolute ; 
        bottom: -6px ; 
        left: 50%; 
        margin-left:-7px;
        width: 0; 
        height: 0; 
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-top: 7px solid #ffffff;
    }

    &.arrow_right:after{
        content: " ";
        position: absolute;
        right: -7px;
        margin-top: -26px;
        width: 0;
        height: 0;
        border-bottom: 7px solid transparent;
        border-top: 7px solid transparent;
        border-left: 7px solid #ffffff;
    }

    .label{
        color: rgba(0,0,0,0.87) ;
        display: inline-block ; 
        font-size: 12px;
        padding: 5px 5px 0px 5px ;
        font-weight: 600; 
        span{
          display:inline-block; 
          text-align:left ;
          margin: 0 5px 5px 0 ;
        }
        h4{
            font-size: 1em ; 
            text-align:left ;
        }
        ol{
            padding-left: 20px ; 
            li{
                padding-left: 5px; 
                text-align:left ;
                font-weight: 400 ; 
            }
        }
      }
      table.val_tooltip{
        tr{
            td{
                background: #fff ; 
                border: solid 1px black ; 
                padding: 3px 10px ; 
            }
        }
    }
}


footer{
  background: $bg ; 
  height: 20px ; 
}

</style>
